import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from './Header';
import LogoutModel from './LogoutModel';
import { Button, Modal } from 'react-bootstrap';
import { searchCredential, selectedpassengerCredential, selectedOriginDropdownCredential, bagCredential, selectedDestinationDropdownCredential, FeeServiceDropdownCredential, PaymentTypeDropdownCredential, redirectToPageCredentials,
         flightManifestDetails, docVerifyCredential, printerPopupSearchPageCredential, initialBaggageCountCredentials, moduleAndLoginDivDisabled, setPrintMode, FetchPrintModeModalStatus } from '../ReduxState';
import { useHistory, useLocation } from 'react-router-dom';
import { FncSearchApi, fncStationsApi, fncFEE, fncSSR, fncGetPayment, fncManifestDetails } from '../Utility/ApiCall.js'
import { monthNames, fncSetIsSelectedToFalse, fncAssignSearchedCheckboxes, fncCheckFlightStatus, fncMulitpleJourneyStatus,fncPageNavigations, shortcutKeyForPage, shortcutKeys, fncCreateDuplicateFlightInfo, fncIconsUpdateOnPassengerSelect, searchPageIconsMapping, fncCheckIfTokenIsExpired, isValidObject, extractBagsFromPassengers, fncFocusElementDependsOnPathLocation, shortcutKeysForPageNavigation, shortcutKeysforHumburgerMenu } from '../Utility/CommonFun.js';
import DatePicker from "react-datepicker";
import onScan from '../../node_modules/onscan.js/onscan';
import * as moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import ReactTooltip from "react-tooltip";
import FocusLock from "react-focus-lock";
import PrintModeModal from '../Components/PrintModeModal.js';


function Search({ handleSideMenu }) {
  const IsModulAndLoginDivDisabled = useSelector(state => state.login.IsModulAndLoginDivDisabled);
  const selectedMode = useSelector(state => state.printMode.selectedMode);
  const PrintModeModalStatus = useSelector(state => state.printMode.PrintModeModalStatus);
  const lastFocusedCheckboxRef = useRef(null);
  const CancleBtnRef = useRef(null);
  const proceed = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0); // Track the active array div
  const [focusSearchbtn, setFocusSearchbtn] = useState(true); // Track the active array div
  const divRefs = useRef([]); // Store references to the array divs
  const datepickerRef = useRef(null); 
  const SegmentRefs = useRef({}); // Store focusable elements inside each div
  const [isAltSActivated, setIsAltSActivated] = useState(false); // Toggle for Alt+S
  const passengerDivRef = useRef(null); // Ref for Passenger List div
  const [divChange, setDivChange] = useState(true); // Toggle for Alt+S div behavior
  const [previousIndex, setPreviousIndex] = useState(null); // Track the previous index
  const [Allpassenger, setAllpassenger] = useState(false); // Track the previous index

        // debugger
        const dispatch = useDispatch();
        const location = useLocation();
        let history = useHistory();
        const inputElementForPNR = useRef(null);
        const yesbutton = useRef(null);
        const [triggerModal, settriggerModal] = useState(false);
        const UserRights = useSelector(state => state.login.CheckInRights);
        const UserBoardingRights = useSelector(state => state.login.BoardingRights);
        const Location = useSelector(state => state.login.Location);
        const manifest = useSelector(state => state.sidemenu);
        const isBagAddedInState = useSelector(state => state.search.isBagAdded);
        const printerPopup = useSelector(state => state.search.isPrinterPopupSearchPageOpen);
        const SearchedSelectedPassengerData = useSelector(state => state.selectedpassenger.SelectedPassengerData);
        const ReduxDestinationDropdown = useSelector(state => state.selectedpassenger.DestinationDropdown);
        const ReduxOriginDropdown = useSelector(state => state.selectedpassenger.OriginDropdown);
        const [paxselection, setSelectedPax] = useState(
                {
                        "RecordLocator": "",
                        "SelectedPassengerKey": [],
                        "SelectedSegmentKey": [],
                        "sDate": "",
                        "firstName": "",
                        "lastName": "",
                        "flightnum": "",
                        "opsuffix": "",
                        "origin": "",
                        "destination": "",
                        "carriercode": process.env.REACT_APP_AirlineCode,
                        "isDisregard": false,
                        "IsQuickSearch": false,
                        "CurrentDateTime": "",
                        "Location":""

                }
        );
        const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
        const SearchedRecordData = useSelector(state => state.search.SearchedRecordData);
        const [stSearchedRecordData, setSearchedRecordData] = useState(SearchedRecordData && SearchedRecordData.length === 0 ? [] : SearchedRecordData);
        const [stSearchedFlightDetails, setSearchedFlightDetails] = useState(SearchedFlightDetails == undefined || SearchedFlightDetails == null ? {} : SearchedFlightDetails);
        const [st_date, setDateToSearch] = useState(SearchedSelectedPassengerData.sDate != undefined && SearchedSelectedPassengerData.sDate != "" ? new Date(SearchedSelectedPassengerData.sDate) : new Date());
        const [firstName, setFirstName] = useState(SearchedSelectedPassengerData.firstName != undefined ? SearchedSelectedPassengerData.firstName : "");
        const [lastName, setLastName] = useState(SearchedSelectedPassengerData.lastName != undefined ? SearchedSelectedPassengerData.lastName : "");
        const [flightnum, setFlightNum] = useState(SearchedSelectedPassengerData.flightnum != undefined ? SearchedSelectedPassengerData.flightnum : "");
        const [recordlocator, setRecordLocator] = useState(SearchedSelectedPassengerData.isDisregard == true ? SearchedSelectedPassengerData.RecordLocator.split('-')[0] : "");
        const [bookingRecordlocator, setBookingRecordLocator] = useState(SearchedSelectedPassengerData.isDisregard == true ? SearchedSelectedPassengerData.RecordLocator.split('-')[0] : "");
        // const [recordlocator, setRecordLocator] = useState((SearchedSelectedPassengerData.isDisregard || SearchedSelectedPassengerData.RecordLocator) ? SearchedSelectedPassengerData.RecordLocator.split('-')[0] : "");
        const [opsuffix, setOPSuffix] = useState(SearchedSelectedPassengerData.opsuffix != undefined ? SearchedSelectedPassengerData.opsuffix : "");
        const [origin, setOrigin] = useState(SearchedSelectedPassengerData.origin != undefined && SearchedSelectedPassengerData.origin != "" ? SearchedSelectedPassengerData.origin : Location === 'HDQ' ? 'DEL' : Location);
        const [destination, setDestination] = useState(SearchedSelectedPassengerData.destination != undefined ? SearchedSelectedPassengerData.destination : "");
        const [carriercode, setCarrierCode] = useState(process.env.REACT_APP_AirlineCode);
        const [isDisabled, setDisable] = useState(false);
        const [isallowonce, setAllowOnce] = useState(true);
        const [st_ErrorDate, setErrorDate] = useState('');
        const [st_ErrorOrigin, setErrorOrigin] = useState('');
        const [st_ErrorCarrierCode, setErrorCarrierCode] = useState('');
        const [st_ErrorRecordLocator, setErrorRecordLocator] = useState('');
        const [st_ErrorBookingRecordLocator, setErrorBookingRecordLocator] = useState('');
        const [st_SearchVisibility, setSearchVisibility] = useState("flex");
        const [st_search, setSearchRecord] = useState('');
        const [PaxChanged, setPaxChanged] = useState(false);
        const [modalShow, setModalShow] = useState(false);
        const handleCloseshowErrorPopup = () => setModalShow(false);
        const [Error_FlightStatus, setErrorFlightStatus] = useState(false);
        const [NODATAFOUND, setNODATAFOUND] = useState(false);
        const [isDisregard, setDisregardCriteria] = useState(SearchedSelectedPassengerData.isDisregard != undefined ? SearchedSelectedPassengerData.isDisregard : false);
        // const [isDisregard, setDisregardCriteria] = useState((SearchedSelectedPassengerData.isDisregard !== undefined && SearchedSelectedPassengerData.isDisregard !== '' && !SearchedSelectedPassengerData.isDisregard && recordlocator) ? true : SearchedSelectedPassengerData.isDisregard !== undefined && SearchedSelectedPassengerData.isDisregard !== '' ? SearchedSelectedPassengerData.isDisregard : false);
        const [isQuickSearch, setQuickSearchCriteria] = useState(false);
        const [selectAllPassenger, setselectAllPassenger] = useState(false);
        const [selectedPnr, setSelectedPnr] = useState('');
        const [eltPnr, setEltPnr] = useState(false);
        const [sodPnr, setSODPnr] = useState(false);
        const [showPrinterPopup, setshowPrinterPopup] = useState(false);
        const [showlocalStoragePrinterPopup, setshowlocalStoragePrinterPopup] = useState(false);
        const initialBagCount = useSelector(state => state.search.initialBaggageCount);
        console.log('SearchedRecordData', printerPopup);
        const searchButtonRef = useRef(null);
        const [lookupshow, setlookupshow] = useState(false);
        const [SearchBtnDisable, setSearchBtnDisable] = useState(false);

        const notify = (e) =>
                toast.error(e, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                });

                useEffect(() => {
                  //         // debugger
                          if (!isQuickSearch && !isDisregard) {
                                  if (bookingRecordlocator !== '') {
                                          setBookingRecordLocator('');
                                  }
                                  if (recordlocator !== '') {
                                          setRecordLocator('');
                                  }
                                  datepickerRef.current?.focus();
                                }else
                          if (!isQuickSearch && isDisregard ) {
                                   inputElementForPNR.current.focus();
                          }else if (isQuickSearch && !isDisregard ) {
                                   inputElementForPNR.current.focus();
                          }
                  //                 //fncTransitionEffect(recordlocator, "RECORDLOCATOR", "clsRecordLocatorField");
                  //                 //fncTransitionEffect(flightnum, "FLIGHTNUM", "clsFlightNoField");
                  //                 //fncTransitionEffect(firstName, "FIRSTNAME", "clsFirstNameField");
                  //                 //fncTransitionEffect(lastName, "LASTNAME", "clsLastNameField");
                  //                 //fncTransitionEffect(opsuffix, "OPSUFFIX", "clsOpSuffixField");
                  //         }
                }, [isQuickSearch,isDisregard])

        /** focus on element on every rennder of component */
        // useEffect(() => {
        //         // console.log('history.replace(location.pathname);', location.pathname)
        //         const handleBackButton = () => {
        //                 history.replace(location.pathname);
        //         };
                
        //         window.addEventListener("popstate", handleBackButton);
                
        //         return () => {
        //                 window.removeEventListener("popstate", handleBackButton);
        //         };
        // }, [history, location.pathname]);
        
        useEffect(() => {
          //         // `current` points to the mounted text input element
          //         inputElementForPNR.current.focus();
          if (!isQuickSearch && isDisregard ) {
                  inputElementForPNR.current.focus();
                }else if (isQuickSearch && !isDisregard ) {
                        inputElementForPNR.current.focus();
                }
        }, []);

        /** focus on element on every rennder of component */
        useEffect(() => {
                if (showPrinterPopup && PrintModeModalStatus && selectedMode == "Native") {
                        yesbutton.current.focus();
                }
        },[showPrinterPopup]);

        useEffect(() => {
                if (isBagAddedInState > 0) {
                        dispatch(bagCredential(
                                {
                                  type: "BAG_ADDED",
                                  isBagAdded: 0
                                }
                        ));
                }
        }, [isBagAddedInState]);

        // update to make isQuickSearch =true
        // i have done this change because when i was coming back from any page payment/service it was showing me payment/search/seat in header at searchpage/lookup
        useEffect(() => {
          setQuickSearchCriteria(true);
          if(isDisregard){
                setDisregardCriteria(false);
          }
          dispatch(docVerifyCredential(
                  {
                      type: '',
                      documentsVerified: false
                  }
              ))
  }, []); 

        useEffect(() => {    
                                
                // Initialize with options
                if (!onScan.isAttachedTo(document)) {
                        onScan.attachTo(document, {
                                onScan: function(sCode, iQty) {
                                        // Alternative to document.addEventListener('scan')                            
                                        if (sCode !== '') {                                     
                                                let pnr = '';
                                                if (sCode.length === 6) {                             
                                                        pnr = sCode;
                                                } else {  
                                                        const scannedString = sCode.split("-");                                                         
                                                        scannedString.forEach((item) => {    
                                                                if (item !== '' && item.length === 6) {
                                                                        pnr = item
                                                                }                         
                                                        });
                                                }
                                                fncOnchange({ target: {value: pnr, id: 'RECORDLOCATOR'} }, "clsRecordLocatorField")                                       
                                                fncOnchangeDisregardCriteria({ target: {checked: true}});
                                                if (location.pathname === '/Search' && document.getElementById("searchBooking")) {
                                                        document.getElementById("searchBooking").click();
                                                }
                                        }
                                },
                                keyCodeMapper: function(oEvent) {                                      
                                        if (oEvent.which === '32') {
                                        return '-';
                                        }
                                        // Fall back to the default decoder in all other cases
                                        return onScan.decodeKeyEvent(oEvent);
                                }
                        });
                } 

                // Remove onScan.js from a DOM element completely on component unmount
                return () => {
                        onScan.detachFrom(document);
                     }
                
        }, []);

        var flightInfoCollection = [];

        const shortcutKeyHandler = (event) => { 
                const tag = event.target.tagName.toLowerCase();
                const isTypingField = tag === 'input' || tag === 'textarea' || event.target.isContentEditable;
                if(shortcutKeysForPageNavigation.includes(event.key)){
                        const path = shortcutKeyForPage(location.pathname, event, SearchedFlightDetails);
                                if (path) {
                                        history.push('/' + path);
                                }
                }
                if (isTypingField && !event.ctrlKey) return;
                if (event.ctrlKey  && shortcutKeys.includes(event.key)) {
                        if (shortcutKeysforHumburgerMenu.includes(event.key)) {
                                 dispatch(redirectToPageCredentials(
                                                      {
                                                        type: "",
                                                        redirectionPage: location.pathname
                                                      }
                                 ));
                        }
                         const path = shortcutKeyForPage(location.pathname, event);
                                if (path) {
                                history.push('/' + path);
                                }
                }
                // debugger
                // console.log('------', !isDisabled && (stSearchedRecordData.length === 1 || (SearchedFlightDetails && SearchedFlightDetails.recordLocator)) && !NODATAFOUND && e.key && shortcutKeys.includes(e.key));
                if (!isDisabled && (stSearchedRecordData.length === 1 || (SearchedFlightDetails && SearchedFlightDetails.recordLocator)) && !NODATAFOUND && event.key && shortcutKeys.includes(event.key)) {
                        const path = shortcutKeyForPage(location.pathname,event);
                        if (path) {
                                history.push('/' + path);    
                        }                                       
                }  
        }

        /** effect for opening/closing side menu using shortcut keys (ALT + e)  */
        useEffect(() => {
                document.addEventListener("keydown", function (event) {  
                  if (event.altKey && (event.key === 'Dead' || event.key === 'e')) {
                    handleSideMenu();
                  }
                })
        });

        // function fncSelectAllPassenger(e) {
        //         debugger
        //         setselectAllPassenger(e.target.checked);
        //         const pnrRecords = [...stSearchedRecordData];
        //         pnrRecords.forEach(s => {
        //                 if (s.recordLocator === selectedPnr) {
        //                         s.currentPnr = s.recordLocator;
        //                         s.passengerData.forEach(pd => {
        //                                 pd.passengers.forEach((p) =>{
        //                                         p.IsSelected = e.target.checked;
        //                                 })
        //                         })
        //                 }
        //         });
        //         // debugger
        //         pnrRecords.forEach(s => {
        //                 s.passengerData.forEach(pd => {
        //                         if (pd.passengers.some(p => p.IsSelected) && pd.segments.some(s => s.IsSelected)) {
        //                                 setDisable(false);
        //                         } else {
        //                                 setDisable(true);
        //                         }
        //                 })
        //         })
        //         setSearchedRecordData(pnrRecords);

        // }
//    i hav add one change inside this function because of disable state it was not doing next() if i deselecting then select
        function fncSelectAllPassenger(e) {
                debugger
                setselectAllPassenger(e.target.checked);
                const pnrRecords = [...stSearchedRecordData];
                let disable = true;
            
                pnrRecords.forEach(s => {
                    if (s.recordLocator?.trim() === selectedPnr?.trim()) {
                        s.currentPnr = s.recordLocator;
            
                        s.passengerData.forEach(pd => {
                            pd.passengers.forEach(p => {
                                p.IsSelected = e.target.checked;
                            });
                        });
                    }
                });
            
                pnrRecords.forEach(s => {
                    s.passengerData.forEach(pd => {
                        if (
                            pd.passengers.some(p => p.IsSelected) &&
                            pd.segments.some(seg => seg.IsSelected)
                        ) {
                            disable = false;
                        }
                    });
                });
            
                setDisable(disable);
                setSearchedRecordData(pnrRecords);
            }
            

        useEffect(() => {
                debugger
                // console.log('stSearchedRecordData',stSearchedRecordData, stSearchedFlightDetails);
                if (stSearchedFlightDetails && stSearchedFlightDetails.journeys) {
                        stSearchedFlightDetails.journeys.forEach((val) => {
                                val.segments.forEach((pax) => {
                                        if (pax.classOfService === 'Z' && pax.productClass === '') {
                                                setEltPnr(true);
                                                setSODPnr(false);
                                        }
                                        else if (pax.classOfService === 'Z' && pax.productClass === 'ZD') {
                                                setSODPnr(true);
                                                setEltPnr(false);
                                        } else {
                                                setSODPnr(false);
                                                setEltPnr(false);
                                        }
                                });
                        });
                }
                if (stSearchedRecordData.length > 0) {
                        let selectedPaxArr = [];
                        let selectedSegArr = [];
                        let selectedPaxCount = 0;
                        let selectedPNR = '';
                        let currentPnr = false;
                        stSearchedRecordData.forEach(s =>

                                s.passengerData.forEach(pd => {
                                        
                                        if (s.currentPnr && selectedPNR === s.currentPnr) {
                                                selectedPNR = s.currentPnr;
                                                currentPnr = true;
                                                // currentPnr = s.currentPnr ;
                                        }
                                        pd.passengers.forEach((p, i, parray) => {
                                                if (p.IsSelected) {
                                                        selectedPaxCount = selectedPaxCount + 1;
                                                        selectedPaxArr = parray;
                                                        selectedSegArr = pd.segments;
                                                        selectedPNR = s.recordLocator;
                                                }
                                        })       
                                })
                        )
                        // if (!currentPnr) {
                                if (selectedPnr === '') {
                                        setSelectedPnr(selectedPNR); 
                                }
                                if ((selectedPaxArr.length > 0 && selectedPaxCount === selectedPaxArr.length) || (currentPnr && selectedPaxArr.length === 0 && selectedPaxCount === 0 && selectAllPassenger)) {
                                        setselectAllPassenger(true);
                                }
                                else {
                                        setselectAllPassenger(false);
                                }
                        // }
                }
                // debugger
                // setTimeout(() => {
                //         if (SearchedFlightDetails && SearchedFlightDetails.recordLocator) {
                //                 document.addEventListener("keydown", shortcutKeyHandler);
                //         }
                //       }, 1000)
                if (SearchedFlightDetails && SearchedFlightDetails.recordLocator) {
                        document.addEventListener("keydown", shortcutKeyHandler);
                }
                
                // cleanup this listener
                return () => {
                        document.removeEventListener('keydown', shortcutKeyHandler);
                };
        }, [stSearchedRecordData, NODATAFOUND, SearchedFlightDetails]);

        useEffect(() => {
                console.log('localStorage.getItem("Printers")', localStorage.getItem("Printers"))
                if (printerPopup) {
                        if (localStorage.getItem("Printers")) {
                        console.log('printers in local storage')
                        setshowlocalStoragePrinterPopup(true);
                }
                else {
                        setshowPrinterPopup(true);
                        console.log(' no printers in local storage')
                     }
                }
                
                
        }, [localStorage.getItem("Printers"), printerPopup]);

        useEffect(() => {
                // debugger
                // navigator.usb.getDevices().then(devices => {
                //         devices.forEach(device => {
                //         console.log('usb.getDevices')
                //         console.log(device.productName);      // "Arduino Micro"
                //         console.log(device.manufacturerName); // "Arduino LLC"
                //         });
                // })
                localStorage.removeItem("COMMENTS");
                localStorage.removeItem("TemporaryFEEANDSSRData");
                document.addEventListener("keyup", function (event) {
                        // debugger
                        if (event.key === 'Enter') {
                                const searchBtn = document.getElementById("searchBooking");
                                const nextBtn = document.getElementById("btnNextButton");
                        
                                if (location.pathname === '/Search' && searchBtn && nextBtn === null) {
                                    searchBtn.click();
                                } else if (nextBtn && nextBtn.disabled === false) {
                                    nextBtn.click();
                                }
                            }
                });
                       if (SearchedRecordData.length === 0) {
                        document.getElementById("btnSearchPassengerRecord").click();

                        fncStationsApi()
                                .then((returnVal) => {
                                        // if((returnVal.status=="401" && returnVal.data=="") || (returnVal.status=="500"))
                                        if (returnVal.status == "401" && returnVal.data == "") {
                                                document.getElementById("showAndHideSpinner").style.display = "none";
                                                //     notify(returnVal.statusText);
                                                settriggerModal(true);
                                        }
                                        else {
                                                if (returnVal.data.isError == false) {

                                                        dispatch(selectedOriginDropdownCredential(
                                                                {
                                                                        type: "",
                                                                        OriginDropdown: returnVal.data.stations,

                                                                }))
                                                        dispatch(selectedDestinationDropdownCredential(
                                                                {
                                                                        type: "",
                                                                        DestinationDropdown: returnVal.data.stations
                                                                }))
                                                }
                                                else {
                                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                                                settriggerModal(true);
                                                        } else {
                                                                notify(returnVal.data.errorDetail.errorMessage);
                                                        }   
                                                }
                                        }
                                })
                                .catch(err => console.log("Axios err: ", err))

                        fncFEE()
                                .then((returnVal) => {
                                        // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                                        if (returnVal.status == "401" && returnVal.data == "") {
                                                document.getElementById("showAndHideSpinner").style.display = "none";
                                                //     notify(returnVal.statusText);
                                                settriggerModal(true);
                                        }
                                        else {
                                                if (returnVal.data.isError == false) {

                                                        var fees = returnVal.data.fees;
                                                         
                                                        fncSSR()
                                                                .then((returnVal) => {
                                                                        // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                                                                        if (returnVal.status == "401" && returnVal.data == "") {
                                                                                document.getElementById("showAndHideSpinner").style.display = "none";
                                                                                //     notify(returnVal.statusText);
                                                                                settriggerModal(true);
                                                                        }
                                                                        else {
                                                                                if (returnVal.data.isError == false) {

                                                                                        var FeeServiceDropDown = fees.concat(returnVal.data.ssRs);


                                                                                        dispatch(FeeServiceDropdownCredential(
                                                                                                {
                                                                                                        type: "",
                                                                                                        FeeServiceDropdown: FeeServiceDropDown
                                                                                                }))
                                                                                }
                                                                                else {
                                                                                        
                                                                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                                                                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                                                                                settriggerModal(true);
                                                                                        } else {
                                                                                                notify(returnVal.data.errorDetail.errorMessage);
                                                                                        }
                                                                                }
                                                                        }
                                                                })
                                                                .catch(err => console.log("Axios err: ", err))

                                                }
                                                else {
                                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                                                settriggerModal(true);
                                                        } else {
                                                                notify(returnVal.data.errorDetail.errorMessage);
                                                        }
                                                }
                                        }
                                })
                                .catch(err => console.log("Axios err: ", err))

                        //---------------------------------------------- FNC Payment ----------------------------------

                        fncGetPayment()
                                .then((returnVal) => {

                                        // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                                        if (returnVal.status == "401" && returnVal.data == "") {
                                                document.getElementById("showAndHideSpinner").style.display = "none";
                                                //     notify(returnVal.statusText);
                                                settriggerModal(true);
                                        }
                                        else {
                                                if (returnVal.data.isError == false) {

                                                        var PaymentType = returnVal.data.paymentMethods;


                                                        dispatch(PaymentTypeDropdownCredential(
                                                                {
                                                                        type: "",
                                                                        PaymentTypeDropdown: PaymentType
                                                                }))
                                                }
                                                else {
                                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                                                settriggerModal(true);
                                                        } else {
                                                                notify(returnVal.data.errorDetail.errorMessage);
                                                        }
                                                }
                                        }
                                })
                                .catch(err => console.log("Axios err: ", err))

                        //------------------------------------------------------------------------------------




                }
                else {
                        dispatch(selectedpassengerCredential(
                                {
                                        type: "",
                                        SelectedPassengerData: {}
                                }
                        ));
                        fncSearchButtonClick("OFFPOPUP");
                }
        }, []);


        // useEffect(()=>{
        //         debugger
        //         document.addEventListener("keyup", function (event) {
        //                 debugger
        //         if (event.key === 'Enter') {  
        //                 if (location.pathname === '/Search' && document.getElementById("searchBooking") && document.getElementById("btnNextButton") === null) {
        //                         document.getElementById("searchBooking").click();                          
        //                 }      
        //                 else if (document.getElementById("btnNextButton").disabled === false && document.getElementById("btnNextButton") != null ) {
        //                 document.getElementById("btnNextButton").click();
        //         }
        //     }
        //         });
        // },[])

         // update for  move to back-page  if class name backBtn is given
         useEffect(() => {
          const handleKeyDown = (event) => {
                const nextBtn = document.getElementById("btnNextButton");
                if(nextBtn !== null){
                        if (event.key === "Escape") {
                                if (searchButtonRef.current && searchButtonRef.current.classList.contains("backBtn")) {
                                              setDisregardCriteria(false);
                                              setQuickSearchCriteria(true);
                                              setSelectedPnr("");
                                      document.getElementById("btnSearchPassengerRecord")?.click();
                                }
                        }
                }
                };
                document.addEventListener("keydown", handleKeyDown);
                return () => { document.removeEventListener("keydown", handleKeyDown); };
          }, []);



        function fncDestinationChange(e) {
                
                // console.log(e);
                var DestinationValue = e.target.value;
                var DestinationID = e.target.id;
                if (DestinationValue.toUpperCase() == "Select a Destination".toUpperCase()) {
                        DestinationValue = "";
                }
                setDestination(DestinationValue);

        }
        function fncOriginChange(e) {
                var originID = e.target.value;
                if (originID.toUpperCase() == "Select a Origin".toUpperCase()) {
                        originID = "";
                }
                setErrorOrigin("");
                setOrigin(originID);
        }
        function fncCheckValidations() {
                if (isDisregard || isQuickSearch) {
                        if (recordlocator == '') {
                                setErrorBookingRecordLocator('*Please select Record Locator.');
                                return false;
                        }
                }
                else {
                        if (st_date == '') {
                                setErrorDate('*Please select Date.');
                                return false;
                        }
                        else if (origin == '' || origin.toUpperCase() == "Select a Orign".toUpperCase()) {
                                setErrorOrigin("*Please select Origin.");
                                return false;
                        }
                        else if (carriercode == '') {
                                setErrorCarrierCode("*Please select Carrier Code.");
                                return false;
                        }

                }
                return true;
        }
// update
        function fncOnchange(e, fieldId) {

          var id = e.target.id;
          var value = e.target.value;
          if (id == "FIRSTNAME") {
                  var regex = /^[a-zA-Z]*$/;
                  if (regex.test(value)) {
                          setFirstName(value.toUpperCase());
                          //fncTransitionEffect(value, id, fieldId);
                  }
          }
          if (id == "LASTNAME") {
                  var regex = /^[a-zA-Z]*$/;
                  if (regex.test(value)) {
                          setLastName(value.toUpperCase());
                          //fncTransitionEffect(value, id, fieldId);
                  }
          }
          if (id == "RECORDLOCATOR") {
                  var alphaNumeric = /^[0-9a-zA-Z]+$/;

                  if (value != "") {
                          if (value.match(alphaNumeric)) {
                                  if (value.length <= 6) {
                                          setRecordLocator(value.toUpperCase());
                                          //fncTransitionEffect(value, id, fieldId);
                                          setErrorRecordLocator('');
                                  }
                          }
                  }
                  else {
                          //fncTransitionEffect(value, id, fieldId);
                          setRecordLocator(value)
                          setErrorRecordLocator('');
                  }
          }
          if (id == "BOOKINGRECORDLOCATOR") {
                  let alphaNumeric = /^[0-9a-zA-Z]+$/;

                  if (value !== "") {
                          if (value.match(alphaNumeric)) {
                                  if (value.length <= 6) {
                                          setBookingRecordLocator(value.toUpperCase());
                                          //fncTransitionEffect(value, id, fieldId);
                                          setErrorBookingRecordLocator('');
                                  }
                          }
                  }
                  else {
                          //fncTransitionEffect(value, id, fieldId);
                          setBookingRecordLocator(value)
                          setErrorBookingRecordLocator('');
                  }                        
          }
          if (id == "FLIGHTNUM") {
                  if (value != "") {
                          if (/^[0-9]+$/.test(value)) {
                                  if (value.length <= 5) {
                                          setFlightNum(value);
                                          //fncTransitionEffect(value, id, fieldId);
                                  }
                          }
                  }
                  else {
                          setFlightNum(value);
                          //fncTransitionEffect(value, id, fieldId);
                  }
          }
          if (id == "OPSUFFIX") {
                  setOPSuffix(value);
                  //fncTransitionEffect(value, id, fieldId);
          }
          // 1/9/25 for move focus to search pnr if quick/active btn is unchecked
          if (!isQuickSearch && !isDisregard) {
                  if (fieldId === "clsRecordLocatorField") {
                  setRecordLocator(e.target.value);
                }
          }
          }
        function fncOnchangeDisregardCriteria(e) {
                // debugger
                setDisregardCriteria(e.target.checked)
                if (isQuickSearch && e.target.checked) {
                        setQuickSearchCriteria(false);
                }
                if (!e.target.checked) {
                        setCarrierCode(process.env.REACT_APP_AirlineCode);
                }
        }

        function fncOnchangeQuickSearchCriteria(e) {
                setQuickSearchCriteria(e.target.checked)
                if (isDisregard && e.target.checked) {
                        setDisregardCriteria(false);
                }
                if (!e.target.checked) {
                        setCarrierCode(process.env.REACT_APP_AirlineCode);
                }
        }

        function fncNext(path) {
                // setSelectedPnr('');

                if(JSON.parse(localStorage.getItem("AddedBags"))!=null)
                {
                        localStorage.removeItem("AddedBags");
                }
                if (isDisregard == true) {
                        paxselection.sDate = "";
                        paxselection.firstName = "";
                        paxselection.lastName = "";
                        paxselection.flightnum = "";
                        paxselection.opsuffix = "";
                        paxselection.origin = "";
                        paxselection.destination = "";
                        paxselection.carriercode = "";
                        paxselection.isDisregard = isDisregard;
                        // paxselection.IsQuickSearch = false;
                        paxselection.CurrentDateTime = "";
                        paxselection.Location = "";
                        paxselection.IsQuickSearch = isQuickSearch;
                }
                if (isQuickSearch) {
                        paxselection.sDate = "";
                        paxselection.firstName = "";
                        paxselection.lastName = "";
                        paxselection.flightnum = "";
                        paxselection.opsuffix = "";
                        paxselection.origin = "";
                        paxselection.destination = "";
                        paxselection.carriercode = "";
                        paxselection.isDisregard = isDisregard;
                        paxselection.IsQuickSearch = isQuickSearch;
                        paxselection.CurrentDateTime = new Date();
                        paxselection.Location = "";
                }
                else {
                        paxselection.sDate = st_date;
                        paxselection.firstName = firstName;
                        paxselection.lastName = lastName;
                        paxselection.flightnum = flightnum;
                        paxselection.opsuffix = opsuffix;
                        paxselection.origin = origin;
                        paxselection.destination = destination;
                        paxselection.carriercode = carriercode;
                        paxselection.isDisregard = isDisregard;
                        paxselection.IsQuickSearch = isQuickSearch;
                        paxselection.CurrentDateTime = "";
                        paxselection.Location = "";
                }
                debugger
                var recordlocator = paxselection.RecordLocator.split('-')[0];
                // debugger
                FncSearchApi("", "", "", "", "", recordlocator, true, "", "", "")
                        .then((returnVal) => {
                                // debugger;
                                // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                                if (returnVal.status == "401" && returnVal.data == "") {
                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                        //     notify(returnVal.statusText);
                                        settriggerModal(true);
                                }
                                else {
                                        // debugger
                                        if (returnVal.data.isError == false) {
                                                if (initialBagCount.length > 0) {
                                                        dispatch(initialBaggageCountCredentials(
                                                                {
                                                                        type: "INITIAL_BAGGAGE_COUNT",
                                                                        initialBaggageCount: []
                                                                }
                                                        ));
                                                }
                                                document.getElementById("showAndHideSpinner").style.display = "none";
                                                var assignStateAgain = fncAssignSearchedCheckboxes(paxselection, returnVal.data.flightDetails, "AUTOSEATASSIGN");
                                                if (isValidObject(returnVal.data.flightDetails)) {
                                                        const bagsArray = extractBagsFromPassengers(returnVal.data.flightDetails);
                                                        if (bagsArray.length > 0) {
                                                                dispatch(initialBaggageCountCredentials(
                                                                        {
                                                                                type: "INITIAL_BAGGAGE_COUNT",
                                                                                initialBaggageCount: bagsArray
                                                                        }
                                                                ));
                                                        }
                                                }
                                                var isMultipleJourneys = fncMulitpleJourneyStatus(assignStateAgain.journeys)
                                                if (isMultipleJourneys == false) {
                                                        setErrorFlightStatus("Please select one journey at a time.")
                                                        setModalShow(true);
                                                        return false;
                                                }
                                                var isFlightCancelled = fncCheckFlightStatus(assignStateAgain.journeys)
                                                if (isFlightCancelled.split("_")[2] == "1") {
                                                        setErrorFlightStatus("The journey has been cancelled.")
                                                        setModalShow(true);
                                                        return false;
                                                }
                                                let selectedSegment = [];
                                                let apiRequest = {};
                                                debugger
                                                if (stSearchedRecordData.length === 1) {
                                                        // stSearchedRecordData.forEach(items => {
                                                        //         items.passengerData.forEach(p => {
                                                        //                 selectedSegment = p.segments.filter(s => s.IsSelected);
                                                        //         });
                                                        // });
                                                        const { passengerData } = stSearchedRecordData[0];
                                                        for (let j = 0; j < passengerData.length; j++) {
                                                                selectedSegment = passengerData[j].segments.filter(s => s.IsSelected);
                                                                if (selectedSegment.length) {
                                                                        break;
                                                                }
                                                        }
                                                        if (selectedSegment.length && selectedSegment[0].legs !== null && selectedSegment[0].legs.length) {
                                                                apiRequest = {
                                                                        LegKey: selectedSegment[0].legs[0].legKey
                                                                }
                                                        } else {
                                                                apiRequest = {
                                                                        Date: selectedSegment[0].departureTime,
                                                                        DepartureStation: selectedSegment[0].origin,
                                                                        ArrivalStation: selectedSegment[0].destination,
                                                                        FlightNo: selectedSegment[0].flightNumber,
                                                                        CarrierCode: selectedSegment[0].carrierCode
                                                                        
                                                                }
                                                        }
                                                } else {
                                                        // stSearchedRecordData.forEach(items => {
                                                        //         items.passengerData.forEach(p => {
                                                        //                 selectedSegment = p.segments.filter(s => s.segmentKey === paxselection.SelectedSegmentKey[0]);
                                                        //         });
                                                        // });
                                                        for(let i = 0; i < stSearchedRecordData.length; i++) {
                                                                for (let j = 0; j < stSearchedRecordData[i].passengerData.length; j++) {
                                                                        selectedSegment = stSearchedRecordData[i].passengerData[j].segments.filter(s => s.IsSelected && s.segmentKey === paxselection.SelectedSegmentKey[0]);
                                                                        if (selectedSegment.length) {
                                                                                break;
                                                                        }     
                                                                }
                                                                if (selectedSegment.length) {
                                                                        break;
                                                                }
                                                        }
                                                        if (selectedSegment.length && selectedSegment[0].legs !== null && selectedSegment[0].legs.length) {
                                                                apiRequest = {
                                                                        LegKey: selectedSegment[0].legs[0].legKey
                                                                }
                                                        } else {
                                                                apiRequest = {
                                                                        Date: selectedSegment[0].departureTime,
                                                                        DepartureStation: selectedSegment[0].origin,
                                                                        ArrivalStation: selectedSegment[0].destination,
                                                                        FlightNo: selectedSegment[0].flightNumber,
                                                                        CarrierCode: selectedSegment[0].carrierCode
                                                                        
                                                                }
                                                        }
                                                }
                                                
                                                // console.log('selectedSegment', selectedSegment);
                                                fncManifestDetails(apiRequest)
                                                .then((response) => {
                                                        if (response.status == "401" && response.data == "") {
                                                                // document.getElementById("showAndHideSpinner").style.display = "none";
                                                                notify(response.statusText);
                                                                // settriggerModal(true);
                                                        } else {
                                                                if (!response.data.isError) {
                                                                        // console.log('response.data', response);
                                                                        dispatch(flightManifestDetails(
                                                                                {
                                                                                        type: "",
                                                                                        manifestDetails: {
                                                                                                totalManifestCounts: response.data.totalManifestCounts,
                                                                                                passengerSummaries: response.data.passengerSummaries
                                                                                        }
                                                                                }
                                                                        ));
                                                                } else {
                                                                        notify(response.data.errorDetail.errorMessage);
                                                                        console.log(response.data.errorDetail);
                                                                }
                                                        }
                                                })
                                                dispatch(searchCredential(
                                                        {
                                                                type: "",
                                                                SearchedRecordData: stSearchedRecordData,
                                                                SearchedFlightDetails: assignStateAgain
                                                        }
                                                ));
                                                dispatch(selectedpassengerCredential(
                                                        {
                                                                type: "",
                                                                SelectedPassengerData: paxselection,
                                                        }
                                                ));
                                                 
                                                let navPage = fncPageNavigations(UserRights,"Search",assignStateAgain)
                                                if (typeof path === 'string') {
                                                        navPage = path;
                                                }
                                                if (history.location.pathname !== '/' + navPage) {
                                                        history.push('/' + navPage);
                                                }
                                                // history.push('/' + navPage);

                                        }
                                        else {
                                                document.getElementById("showAndHideSpinner").style.display = "none";
                                                if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                                        settriggerModal(true);
                                                } else {
                                                        notify(returnVal.data.errorDetail.errorMessage);
                                                }
                                                console.log(returnVal.data.errorDetail);
                                        }
                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                }

                        })
                        .catch(err => console.log("Axios err: ", err))

        }

        function fncSearchDivOpen() {
               debugger 
        //        setOrigin(SearchedSelectedPassengerData.origin !== undefined && SearchedSelectedPassengerData.origin !== "" 
        //                ? SearchedSelectedPassengerData.origin 
        //                : Location === 'HDQ' 
        //                ? 'DEL' 
        //                : Location);
                //        if(inputElementForPNR.current){
                //         inputElementForPNR.current.focus()
                //        }
                setDisregardCriteria(false);
                setQuickSearchCriteria(true);
                setRecordLocator("");
                window.scrollTo(0, 0)
                setSearchVisibility("none");
        }
        
        function fncCancelClose() {
                window.scrollTo(0, 0)
                setSearchVisibility("flex");
        }

        function fncCreateFlightInfoData(jsonData, flightDetails) {
                debugger

                jsonData.flightInfo.forEach((val, j) => {
                        val.IsSelected = false;
                        val.segments.forEach((seg, i) => {
                                seg.IsSelected = false;
                                seg.IsAlreadyChecked = false;
                        })
                        val.passengers.forEach((pax, i) => {
                                pax.IsSelected = false;
                        })
                })

                var AllData = [];
                var countOfIndex=0;

                for (var i = 0; i < jsonData.flightInfo.length; i++) {
                
                        var dupArray = [];
                        flightInfoCollection = [];
                        var segments = jsonData.flightInfo[i].segments;
                        var passengers = jsonData.flightInfo[i].passengers;
                        for (var j = 0; j < segments.length; j++) {
                                var passengerSegment = segments[j].passengerSegments
                                for (var k = 0; k < passengerSegment.length; k++) {
                                        dupArray.push({
                                                "passengerKey": passengerSegment[k].passengerKey,
                                                "liftStatus": passengerSegment[k].liftStatus
                                        })
                                }

                        }

                        // creating liftstatus of mulitple segments
                        var newArray = []
                        for (var ii = 0; ii < passengers.length; ii++) {
                                var liftStatus = "";
                                for (var jj = 0; jj < dupArray.length; jj++) {
                                        if (passengers[ii].passengerKey == dupArray[jj].passengerKey) {
                                                liftStatus = liftStatus + dupArray[jj].liftStatus
                                        }
                                }
                                newArray.push({
                                        "passengerKey": passengers[ii].passengerKey,
                                        "liftStatus": liftStatus
                                })
                        }

                        let result = newArray.reduce((initialValue, currentValue, currentIndex, array) => {

                                if (!initialValue[currentValue.liftStatus]) {
                                        initialValue[currentValue.liftStatus] = {
                                                count: 1,
                                                index: currentIndex.toString()
                                        }
                                } else {
                                        if ((array[currentIndex + 1] && array[currentIndex + 1].liftStatus !== currentValue) || !array[currentIndex + 1]) {
                                                initialValue[currentValue.liftStatus].index += '-' + currentIndex;
                                        }
                                        else {
                                                initialValue[currentValue.liftStatus].index += '-' + currentIndex;
                                                initialValue[currentValue.liftStatus].count++
                                        }
                                }
                                return initialValue;
                        }, {})

                         

                        /** getting unique values for iterations */
                        var unique = [...new Set(newArray.map(item => item.liftStatus))];

                        /** creating segments and passenger data for collection */
                        for (var a = 0; a < unique.length; a++) {
                                var indexPositions = result[unique[a]].index;
                                fncCreateDuplicateFlightInfo(jsonData.flightInfo[i].recordLocator, segments, passengers, indexPositions, dupArray,countOfIndex, flightInfoCollection, Location, stSearchedFlightDetails.recordLocator ?  stSearchedFlightDetails: flightDetails);
                                countOfIndex=countOfIndex+1;
                        }

                        AllData.push({
                                "passengerCount": jsonData.flightInfo[i].passengerCount,
                                "recordLocator": jsonData.flightInfo[i].recordLocator,
                                "passengerData": flightInfoCollection
                        })
                }
                
                keepDataInLocalStorage(AllData, "0-0", AllData[0].recordLocator)

                let selectedPaxCount = 0;
                let selectedSegCount = 0;

                AllData.forEach(s =>

                        s.passengerData.forEach(pd => {
                                
                                
                                pd.passengers.forEach((p, i, parray) => {
                                        if (p.IsSelected) {
                                                selectedPaxCount = selectedPaxCount + 1;
                                                
                                        }
                                }) 
                                pd.segments.forEach((p, i, parray) => {
                                        if (p.IsSelected) {
                                                selectedSegCount = selectedSegCount + 1;
                                                
                                        }
                                })        
                        })
                )
                if (selectedSegCount > 0 && selectedPaxCount > 0) {
                        setDisable(false);
                }
                
                setSearchedRecordData(AllData);
        }

        function fncSearchButtonClick(FROM) {
        //   debugger
          setDisable(true);
          var isValid = fncCheckValidations();
          if (isValid ) {
                // setDateToSearch('')
                // setOrigin('');
                // setCarrierCode('');
                  if (FROM != "OFFPOPUP") {
                          document.getElementById("btnSearchPassengerRecord").click();
                  }
                  setSearchVisibility("flex");
                  var vdate = "";
                  var vorigin = "";
                  var vdestination = "";
                  var vfirstname = "";
                  var vlastname = "";
                  var vrecordlocator = "";
                  var visDisregard = false;
                  var vcarriercode = "";
                  var vflightnum = "";
                  var vopsuffix = "";
                  var viIsQuickSearch = false;
                  var viCurrentDateTime = "";
                  var viLocation = "";


                  if (isDisregard) {
                          vdate = "";
                          vorigin = "";
                          vdestination = "";
                          vfirstname = "";
                          vlastname = "";
                          vrecordlocator = recordlocator;
                          visDisregard = isDisregard;
                          vcarriercode = "";
                          vflightnum = "";
                          vopsuffix = "";
                          viIsQuickSearch = isQuickSearch;
                          viCurrentDateTime = "";
                          viLocation = "";
                  }
                  else if (isQuickSearch) {
                          const currentdate = new Date(); //"2010-08-17 12:09:36"
                          let month = currentdate.getMonth() + 1;
                          if (month < 10) {
                                  month = `0${month}`
                          }
                          const cDate = `${currentdate.getFullYear()}-${month}-${currentdate.getDate()} ${currentdate.getHours()}:${currentdate.getMinutes()}:${currentdate.getSeconds()}`;
                          vdate = "";
                          vorigin = "";
                          vdestination = "";
                          vfirstname = "";
                          vlastname = "";
                          vrecordlocator = recordlocator;
                          visDisregard = isDisregard;
                          vcarriercode = "";
                          vflightnum = "";
                          vopsuffix = "";
                          viIsQuickSearch = isQuickSearch;
                          viCurrentDateTime = cDate;
                          viLocation = Location;
                  }
                  else {
                          vdate = new Date(st_date).getFullYear() + "-" + (parseInt(new Date(st_date).getMonth()) + 1) + "-" + new Date(st_date).getDate();;
                          vorigin = origin;
                          vdestination = destination;
                          vfirstname = firstName;
                          vlastname = lastName;
                          vrecordlocator = bookingRecordlocator;
                          visDisregard = isDisregard;
                          vcarriercode = carriercode;
                          vflightnum = flightnum;
                          vopsuffix = opsuffix;
                          viIsQuickSearch = isQuickSearch;
                  }
                  
                  if (stSearchedRecordData.length > 0 && stSearchedFlightDetails) {
                          dispatch(searchCredential(
                                  {
                                          type: "",
                                          SearchedRecordData: [],
                                          SearchedFlightDetails: {}
                                  }
                          ));
                          dispatch(selectedpassengerCredential(
                                  {
                                          type: "",
                                          SelectedPassengerData: {},

                                  }
                          ));
                          setSearchedRecordData([]);
                          setSearchedFlightDetails({});
                  }

                  FncSearchApi(vdate, vorigin, vdestination, vfirstname, vlastname, vrecordlocator, visDisregard, vcarriercode, vflightnum, vopsuffix, viIsQuickSearch, viCurrentDateTime, viLocation)
                          .then((returnVal) => {
                                  // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                                  if (returnVal.status == "401" && returnVal.data == "") {
                                          document.getElementById("showAndHideSpinner").style.display = "none";
                                          //     notify(returnVal.statusText);
                                          settriggerModal(true);
                                  }
                                  else {
                                          // document.getElementById("showAndHideSpinner").style.display = "none";
                                          if (returnVal.data.isError == false) {
                                                  dispatch(searchCredential(
                                                          {
                                                                  type: "",
                                                                  SearchedRecordData: [],
                                                                  SearchedFlightDetails: {}
                                                          }
                                                  ));
                                                  dispatch(selectedpassengerCredential(
                                                          {
                                                                  type: "",
                                                                  SelectedPassengerData: {},

                                                          }
                                                  ));
                                                  if (NODATAFOUND) {
                                                          setNODATAFOUND(false);
                                                  }
                                                  // setNODATAFOUND(false);
                                                  // CHANGED ON 28 MAY---
                                                  if (returnVal.data.flightInfo == null) {
                                                          setNODATAFOUND(true);
                                                  }
                                                  else {  
                                                          if (returnVal.data.flightDetails !== null && returnVal.data.flightDetails.journeys === null) {
                                                                  notify('PNR is cancelled, we cannot proceed further.');
                                                                  // window.scrollTo(0, 0)
                                                                  // setSearchVisibility("none");
                                                          } else {
                                                                  var vflightDetails = returnVal.data.flightDetails;
                                                                  if (returnVal.data.flightDetails !== null) {
                                                                          // debugger
                                                                          vflightDetails = fncSetIsSelectedToFalse(returnVal);
                                                                          // setSearchedRecordData(returnVal.data.flightInfo);
                                                                          setSearchedFlightDetails(vflightDetails.data.flightDetails);
                                                                          fncCreateFlightInfoData(returnVal.data, vflightDetails.data.flightDetails)
                                                                          

                                                                  }
                                                                  else {
                                                                          fncCreateFlightInfoData(returnVal.data)
                                                                          // setSearchedRecordData(returnVal.data.flightInfo);
                                                                  }

                                                                  if (isDisregard || isQuickSearch) {
                                                                          // debugger
                                                                          const assignStateAgain = fncAssignSearchedCheckboxes(paxselection, returnVal.data.flightDetails, "AUTOSEATASSIGN");
                                                                          // var isFlightCancelled = fncCheckFlightStatus(assignStateAgain.journeys)
                                                                          dispatch(searchCredential(
                                                                                  {
                                                                                          type: "",
                                                                                          SearchedRecordData: [{
                                                                                                  "passengerCount": returnVal.data.flightInfo[0].passengerCount,
                                                                                                  "recordLocator": returnVal.data.flightInfo[0].recordLocator,
                                                                                                  "passengerData": flightInfoCollection
                                                                                          }],
                                                                                          SearchedFlightDetails: assignStateAgain
                                                                                  }
                                                                          ));
                                                                          dispatch(selectedpassengerCredential(
                                                                                  {
                                                                                          type: "",
                                                                                          SelectedPassengerData: paxselection,
                                                                                  }
                                                                          ));
          
                                                                  }
                                                          }  
                                                  }
                                                  // // update 
                                                  document.getElementById("showAndHideSpinner").style.display = "none";
                                                  if (divRefs.current[activeIndex]) {
                                                          divRefs.tabIndex === activeIndex ? 0 : -1;
                                                          divRefs.current[activeIndex].focus();
                                                          // console.log("Focused on:", divRefs.current[activeIndex]);
                                                        } else {
                                                          console.warn("divRefs at activeIndex not found");
                                                        }
                                          }
                                          else {
                                                  document.getElementById("showAndHideSpinner").style.display = "none";
                                                if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                                        settriggerModal(true);
                                                } else {
                                                  setSearchedRecordData([]);
                                                  setRecordLocator('');
                                                  setDisregardCriteria(false);
                                                  setQuickSearchCriteria(false);
                                                  dispatch(searchCredential(
                                                          {
                                                                  type: "",
                                                                  SearchedRecordData: [],
                                                                  SearchedFlightDetails: {}
                                                          }
                                                  ));
                                                  dispatch(selectedpassengerCredential(
                                                          {
                                                                  type: "",
                                                                  SelectedPassengerData: {},

                                                          }
                                                  ));
                                                  setNODATAFOUND(false);
                                                  notify(returnVal.data.errorDetail.errorMessage);
                                                  console.log(returnVal.data.errorDetail);
                                                }
                                          }
                                  }
                          })
                          .catch(err => console.log("Axios err: ", err))
          }
  }

        function fncPassengerSelection(e, recordLocator, choice, Name, indexes) {
                debugger
 // to take index of parent div with classname =divborder 3827-3831
 const parentDiv = e.target.closest(".divborder");
 if (!parentDiv) return;    
 const parentIndex = [...document.querySelectorAll(".divborder")].indexOf(parentDiv);
   //   console.log("Parent Div Index:", parentIndex);
 setActiveIndex(parentIndex);
                // debugger
                var arrName = [];
                var arrSegment = [];
                var value = "";
                if(Name=="AUTOSELECTION")
                {
                        value = e;
                }
                else
                {
                        value = e.target.id;     
                }
                var CheckedPassengerKey = [...stSearchedRecordData];
                var isPaxSelected = false;
                let selectedPassengerCount = 0;
                var isSegSelected = false;
                var recordlocatorPosition = indexes.split('-')[0];
                var PassengerDataPosition = indexes.split('-')[1];


                CheckedPassengerKey.forEach((start, i) => {
                        if (i == recordlocatorPosition) {
                                start.passengerData.forEach((val, j) => {


                                        if (j == PassengerDataPosition) {

                                                // -------------------- selected rows-------------------              
                                                if (choice == "PASSENGER") {
                                                        val.passengers.forEach((pax) => {
                                                                if (start.recordLocator + "-" + j == recordLocator && paxselection.RecordLocator != recordLocator) {
                                                                        if (pax.passengerKey == value) {
                                                                                arrName.push(pax.title + "" + pax.firstName + '' + pax.lastName);
                                                                                pax.IsSelected = e.target.checked;
                                                                                isPaxSelected = true;
                                                                        }
                                                                }
                                                                else if (start.recordLocator + "-" + j == recordLocator) {
                                                                        if (pax.passengerKey == value) {
                                                                                pax.IsSelected = e.target.checked;
                                                                        }
                                                                        if (pax.IsSelected) {
                                                                                isPaxSelected = true;
                                                                        }
                                                                }
                                                                else {
                                                                        pax.IsSelected = false;
                                                                }
                                                        })
                                                        // Count selected passengers
                                                        selectedPassengerCount = val.passengers.filter(pax => pax.IsSelected).length;
                                                        var count = 0;
                                                        val.segments.forEach((seg, i) => {
                                                                if (seg.IsAlreadyChecked) {
                                                                        count = count + 1;
                                                                }
                                                        })

                                                        if (count != val.segments.length && count > 0) {
                                                                val.segments.forEach((seg) => {
                                                                        if (seg.IsAlreadyChecked) {
                                                                                if (!stSearchedFlightDetails) {         // Object.keys(stSearchedFlightDetails).length !== 0
                                                                                        if (start.recordLocator + "-" + j == recordLocator && paxselection.RecordLocator != recordLocator) {
                                                                                                arrSegment.push(seg.segmentKey);
                                                                                                seg.IsSelected = e.target.checked;
                                                                                                isSegSelected = true;
                                                                                        }
                                                                                }
                                                                                // if (start.recordLocator + "-" + j == recordLocator && paxselection.RecordLocator != recordLocator) {
                                                                                //         arrSegment.push(seg.segmentKey);
                                                                                //         seg.IsSelected = e.target.checked;
                                                                                //         isSegSelected = true;
                                                                                // } else
                                                                                if (start.recordLocator + "-" + j == recordLocator) {
                                                                                        if (seg.IsSelected) {
                                                                                                isSegSelected = true;
                                                                                        }
                                                                                }
                                                                                else {
                                                                                        seg.IsSelected = false;
                                                                                }
                                                                        }
                                                                        else {
                                                                                if (e.target.checked) {
                                                                                        isSegSelected = true;
                                                                                }
                                                                        }
                                                                })
                                                        }
                                                        else {
                                                                val.segments.forEach((seg) => {
                                                                        if (!stSearchedFlightDetails) {                                                                              
                                                                                if (start.recordLocator + "-" + j == recordLocator && paxselection.RecordLocator != recordLocator) {
                                                                                        arrSegment.push(seg.segmentKey);
                                                                                        seg.IsSelected = e.target.checked;
                                                                                        isSegSelected = true;
                                                                                }  
                                                                        }
                                                                        // if (start.recordLocator + "-" + j == recordLocator && paxselection.RecordLocator != recordLocator) {
                                                                        //         arrSegment.push(seg.segmentKey);
                                                                        //         seg.IsSelected = e.target.checked;
                                                                        //         isSegSelected = true;
                                                                        // } else 
                                                                        if (start.recordLocator + "-" + j == recordLocator) {
                                                                                if (seg.IsSelected) {
                                                                                        isSegSelected = true;
                                                                                }
                                                                        }
                                                                        else {
                                                                                seg.IsSelected = false;
                                                                        }
                                                                })
                                                        }



                                                }
                                                else {
                                                        setSelectedPnr(recordlocator.substr(0, recordLocator.indexOf('-')));
                                                        // similar recordlocator but for segments ----
                                                        const SelectedSeg = val.segments.filter(seg => seg.segmentKey === value);
                                                        const jKeyForSelectedSeg = SelectedSeg[0].journeyKey;
                                                        const currentselectedSeg = SelectedSeg[0];
                                                        val.segments.forEach((seg) => {


                                                                var count = 0;

                                                                val.segments.forEach((seg, i) => {
                                                                        if (seg.IsAlreadyChecked) {
                                                                                count = count + 1;
                                                                        }
                                                                })
                                                                if (count !== val.segments.length && count > 0) {
                                                                        
                                                                        if (start.recordLocator + "-" + j == recordLocator && paxselection.RecordLocator != recordLocator) {
                                                                                if (seg.segmentKey === value && jKeyForSelectedSeg === seg.journeyKey) {                                                                                
                                                                                        if (seg.IsAlreadyChecked == false) {
                                                                                                arrSegment.push(seg.segmentKey);
                                                                                                seg.IsSelected = e.target.checked;
                                                                                                isSegSelected = true;
                                                                                        }
                                                                                        else {
                                                                                                arrSegment.push(seg.segmentKey);
                                                                                                seg.IsSelected = e.target.checked;
                                                                                                isSegSelected = true;
                                                                                                // if (seg.IsSelected == true) {
                                                                                                //         arrSegment.push(seg.segmentKey);
                                                                                                //         seg.IsSelected = e.target.checked;
                                                                                                //         isSegSelected = true;
                                                                                                // }
                                                                                                // else {
                                                                                                //         arrSegment.push(seg.segmentKey);
                                                                                                //         seg.IsSelected = !e.target.checked;
                                                                                                //         isSegSelected = true;
                                                                                                // }

                                                                                        }
                                                                                        
                                                                                }
                                                                                if (jKeyForSelectedSeg === seg.journeyKey && seg.segmentKey !== value) {
                                                                                        if (seg.IsSelected && !seg.IsAlreadyChecked && currentselectedSeg.IsAlreadyChecked && e.target.checked) {
                                                                                                seg.IsSelected = false;                                                                                             
                                                                                        }
                                                                                        if (seg.IsSelected && seg.IsAlreadyChecked && !currentselectedSeg.IsAlreadyChecked && e.target.checked) {
                                                                                                seg.IsSelected = false;
                                                                                        }
                                                                                        isSegSelected = true;
                                                                                }
                                                                                if (jKeyForSelectedSeg !== seg.journeyKey ) {//&& seg.IsSelected !== e.target.checked
                                                                                        // seg.IsSelected = !e.target.checked;
                                                                                        // isSegSelected = true;
                                                                                        if (seg.IsSelected) {
                                                                                                seg.IsSelected = false;
                                                                                                isSegSelected = true;
                                                                                        }
                                                                                }

                                                                        }
                                                                        else if (start.recordLocator + "-" + j == recordLocator) {
                                                                                if (seg.segmentKey === value && jKeyForSelectedSeg === seg.journeyKey) {
                                                                                        seg.IsSelected = e.target.checked;
                                                                                        if (seg.IsSelected) {
                                                                                                isSegSelected = true;
                                                                                        }
                                                                                }
                                                                                if (jKeyForSelectedSeg === seg.journeyKey && seg.segmentKey !== value) {
                                                                                        if (seg.IsSelected && !seg.IsAlreadyChecked && currentselectedSeg.IsAlreadyChecked && e.target.checked) {
                                                                                                seg.IsSelected = false;                                                                                             
                                                                                        }
                                                                                        if (seg.IsSelected && seg.IsAlreadyChecked && !currentselectedSeg.IsAlreadyChecked && e.target.checked) {
                                                                                                seg.IsSelected = false;
                                                                                        }
                                                                                        isSegSelected = true;
                                                                                }
                                                                                if (jKeyForSelectedSeg !== seg.journeyKey) {
                                                                                        if (e.target.checked) {
                                                                                                seg.IsSelected = !e.target.checked;
                                                                                        }
                                                                                        
                                                                                }

                                                                        }
                                                                        else {
                                                                                seg.IsSelected = false;
                                                                        }
                                                                }
                                                                else {
                                                                        if (start.recordLocator + "-" + j == recordLocator && paxselection.RecordLocator != recordLocator) {
                                                                                if (jKeyForSelectedSeg === seg.journeyKey && seg.segmentKey == value) {
                                                                                        arrSegment.push(seg.segmentKey);
                                                                                        seg.IsSelected = e.target.checked;
                                                                                        isSegSelected = true;
                                                                                }
                                                                                if (jKeyForSelectedSeg === seg.journeyKey && seg.segmentKey !== value) {
                                                                                        if (seg.IsSelected && !seg.IsAlreadyChecked && currentselectedSeg.IsAlreadyChecked && e.target.checked) {
                                                                                                seg.IsSelected = false;                                                                                             
                                                                                        }
                                                                                        if (seg.IsSelected && seg.IsAlreadyChecked && !currentselectedSeg.IsAlreadyChecked && e.target.checked) {
                                                                                                seg.IsSelected = false;
                                                                                        }
                                                                                        isSegSelected = true;
                                                                                }
                                                                                if (jKeyForSelectedSeg !== seg.journeyKey) {
                                                                                        if (seg.IsSelected) {
                                                                                                seg.IsSelected = false;
                                                                                                isSegSelected = true;
                                                                                        }
                                                                                        // seg.IsSelected = false;
                                                                                }                                                                             
                                                                        }
                                                                        else if (start.recordLocator + "-" + j == recordLocator) {
                                                                                // if (jKeyForSelectedSeg === seg.journeyKey) {
                                                                                //         seg.IsSelected = e.target.checked;
                                                                                //         if (seg.IsSelected) {
                                                                                //                 isSegSelected = true;
                                                                                //         }
                                                                                // }
                                                                                if (seg.segmentKey === value && jKeyForSelectedSeg === seg.journeyKey) {
                                                                                        seg.IsSelected = e.target.checked;
                                                                                }
                                                                                if (jKeyForSelectedSeg === seg.journeyKey && seg.segmentKey !== value) {
                                                                                        if (seg.IsSelected && !seg.IsAlreadyChecked && currentselectedSeg.IsAlreadyChecked && e.target.checked) {
                                                                                                seg.IsSelected = false;                                                                                             
                                                                                        }
                                                                                        if (seg.IsSelected && seg.IsAlreadyChecked && !currentselectedSeg.IsAlreadyChecked && e.target.checked) {
                                                                                                seg.IsSelected = false;
                                                                                        }
                                                                                        isSegSelected = true;
                                                                                }
                                                                                if (jKeyForSelectedSeg !== seg.journeyKey) {
                                                                                        if (seg.IsSelected) {
                                                                                                seg.IsSelected = false;
                                                                                                isSegSelected = true;
                                                                                        }
                                                                                        // seg.IsSelected = false;
                                                                                }
                                                                                if (seg.IsSelected) {
                                                                                        isSegSelected = true;
                                                                                }
                                                                        }
                                                                        else {
                                                                                seg.IsSelected = false;
                                                                        }
                                                                }
                                                        })

                                                        val.passengers.forEach((pax) => {
                                                                if (start.recordLocator + "-" + j == recordLocator && paxselection.RecordLocator != recordLocator) {
                                                                        var count = 0;
                                                                        val.segments.forEach((seg, i) => {
                                                                                if (seg.IsAlreadyChecked) {
                                                                                        count = count + 1;
                                                                                }
                                                                        })
                                                                        if (count != val.segments.length && count > 0) {
                                                                                arrName.push(pax.title + "" + pax.firstName + '' + pax.lastName);
                                                                                pax.IsSelected = true;
                                                                                isPaxSelected = true;
                                                                        }
                                                                        else {
                                                                                arrName.push(pax.title + "" + pax.firstName + '' + pax.lastName);
                                                                                pax.IsSelected = true;
                                                                                isPaxSelected = true;
                                                                        }
                                                                }
                                                                else if (start.recordLocator + "-" + j == recordLocator) {
                                                                        if (pax.IsSelected) {
                                                                                isPaxSelected = true;
                                                                        }
                                                                }
                                                                else {
                                                                        pax.IsSelected = false;
                                                                }
                                                        })
                                                }
                                                selectedPassengerCount = val.passengers.filter(pax => pax.IsSelected).length;
                                                // -------------------- selected rows ends here -----------------------
                                        }
                                        else {

                                                // ------------------- same recordlocator but different row selected  --------------------------

                                                val.passengers.forEach((pax) => {
                                                        pax.IsSelected = false;
                                                })

                                                let count = 0;
                                                val.segments.forEach((seg, i) => {
                                                        if (val.passengers.some(p => p.IsSelected)) {
                                                                if (seg.IsAlreadyChecked) {
                                                                        count = count + 1;
                                                                }
                                                        }       
                                                })

                                                if (count !== val.segments.length && count > 0) {
                                                        if (val.passengers.some(p => p.IsSelected)) {
                                                                val.segments.forEach((seg) => {
                                                                        if (seg.IsAlreadyChecked) {
                                                                                seg.IsSelected = true;
                                                                        }
                                                                        else {
                                                                                seg.IsSelected = false;
                                                                        }
                                                                })
                                                        }

                                                }
                                                else {
                                                        val.segments.forEach((seg) => {
                                                                seg.IsSelected = false;
                                                        })
                                                }



                                                //------------------------ non selected rows ends here -----------------------

                                        }

                                        if (!isSegSelected) {
                                                setModalShow(true);
                                                setDisable(true);
                                                setErrorFlightStatus("No segment selected.");
                                                return;
                                        }else  
                                        if (selectedPassengerCount === 0) {
                                                setModalShow(true);
                                                setDisable(true);
                                                setErrorFlightStatus("Please select at least one passenger.");
                                                return;
                                            }else{
                                               setDisable(false);
                                            }

                                })
                        }
                        else {

                                // for other PNR non selection  starts here ------------------------------------------------------

                                start.passengerData.forEach((val, j) => {


                                        // ------------------- non selected rows  --------------------------

                                        val.passengers.forEach((pax) => {
                                                pax.IsSelected = false;
                                        })

                                        var count = 0;
                                        val.segments.forEach((seg, i) => {
                                                if (seg.IsAlreadyChecked) {
                                                        count = count + 1;
                                                }
                                        })

                                        if (count != val.segments.length && count > 0) {
                                                val.segments.forEach((seg) => {
                                                        if (seg.IsAlreadyChecked) {
                                                                seg.IsSelected = true;
                                                        }
                                                        else {
                                                                seg.IsSelected = false;
                                                        }
                                                })

                                        }
                                        else {
                                                val.segments.forEach((seg) => {
                                                        seg.IsSelected = false;
                                                })
                                        }




                                        //------------------------ non selected rows ends here -----------------------


                                })
                                // for other PNR non selection ends here----------------------------
                        }
                })


                // loops finished
                if (Object.keys(stSearchedFlightDetails).length !== 0 && stSearchedRecordData.length === 1) {
                        CheckedPassengerKey.forEach(cpax => {
                                cpax.passengerData.forEach(pdata => {
                                        isSegSelected = pdata.segments.some(seg => {
                                                return seg.IsSelected;
                                        })
                                })
                        })
                }
                if (Object.keys(stSearchedFlightDetails).length !== 0 && stSearchedRecordData.length === 1) {
                        let passengersArray = [];
                        let segArray = [];
                        
                        
                        
                        CheckedPassengerKey.forEach(cpax => {
                                cpax.passengerData.forEach(pdata => {  
                                        pdata.passengers.forEach(p => {
                                                passengersArray = passengersArray.concat(p);
                                        })
                                                                           
                                        pdata.segments.forEach(s => {
                                                segArray = segArray.concat(s);
                                        })
                                })
                        })
                        isPaxSelected = passengersArray.some(p => {
                                return p.IsSelected;
                        })
                        isSegSelected = segArray.some(seg => {
                                return seg.IsSelected;
                        })
                }
                fncIconsUpdateOnPassengerSelect(CheckedPassengerKey, stSearchedFlightDetails);
                if (isPaxSelected && isSegSelected && selectedPassengerCount > 0 ) {
                        setDisable(false);
                }
                else {
                        setDisable(true);
                }

                setSearchedRecordData(CheckedPassengerKey);
                keepDataInLocalStorage(CheckedPassengerKey, indexes, recordLocator)
                //     keepDataInLocalStorage(e,recordLocator,choice,Name,arrName,arrSegment)   
        }

        // function keepDataInLocalStorage(e,recordLocator,choice,Name,arrName,arrSegment)
        function keepDataInLocalStorage(CheckedPassengerKey, indexes, recordLocator) {
                   
                var arrName = [];
                var arrSegment = [];
                var recordlocatorPosition = indexes.split('-')[0];
                var PassengerDataPosition = indexes.split('-')[1];
                   
                CheckedPassengerKey.forEach((start, i) => {
                        if (i == recordlocatorPosition) {
                                start.passengerData.forEach((val, j) => {
                                        if (j == PassengerDataPosition) {
                                                val.passengers.forEach((pax) => {
                                                        if (pax.IsSelected) {
                                                                arrName.push(pax.title + "" + pax.firstName + '' + pax.lastName);
                                                        }
                                                })
                                                val.segments.forEach((seg) => {
                                                        if (seg.IsSelected) {
                                                                arrSegment.push(seg.segmentKey);
                                                        }
                                                })
                                        }
                                })
                        }
                });



                var CheckedPassengerKey = paxselection;
                if (paxselection.RecordLocator != recordLocator) {
                        CheckedPassengerKey.SelectedPassengerKey = [];
                        CheckedPassengerKey.SelectedSegmentKey = [];
                        CheckedPassengerKey.SelectedPassengerKey = arrName;
                        CheckedPassengerKey.SelectedSegmentKey = arrSegment;
                        setPaxChanged(true);
                        CheckedPassengerKey.RecordLocator = recordLocator;
                        setAllowOnce(false)
                        setSelectedPax(CheckedPassengerKey);
                }
                else if (CheckedPassengerKey.RecordLocator == recordLocator) {
                        CheckedPassengerKey.SelectedPassengerKey = arrName;
                        CheckedPassengerKey.SelectedSegmentKey = arrSegment;
                        CheckedPassengerKey.RecordLocator = recordLocator;
                        setAllowOnce(false)
                        setSelectedPax(CheckedPassengerKey);
                }

        }

        function handleDateChange(e) {

                console.log(e);
                setErrorDate('');
                setDateToSearch(e);
        }
        function handleDateSelect(e) {
                setErrorDate('');
                setDateToSearch(e);
        }
        function fncGoToPeripheralDevices() {
                setshowPrinterPopup(false);
                setshowlocalStoragePrinterPopup(false);
                disablePrinterPopup()
                history.push('/PeripheralDevices');
        }

        function fncPopupCancelClick() {
                setshowlocalStoragePrinterPopup(false);
                setshowPrinterPopup(false);
                disablePrinterPopup()
        }

        // useEffect(() => {
        //         // Define the function that checks for the Escape key
        //         const handleKeyDown = (event) => {
        //           if (event.key === "Escape") {
        //                 // fncSearchDivOpen();
        //                 // fncPopupCancelClick(); // Close the popup
        //           }
        //         };
            
        //         // Add the event listener when the component mounts
        //         window.addEventListener("keydown", handleKeyDown);
            
        //         // Clean up the event listener when the component unmounts
        //         return () => {
        //           window.removeEventListener("keydown", handleKeyDown);
        //         };
        // }, []);

        // useEffect(() => {
        //         document.addEventListener("keydown", function (event) {
        //           if (event.key && shortcutKeys.includes(event.key)) {
        //             if (['d'].includes(event.key)) {
        //               dispatch(redirectToPageCredentials(
        //                 {
        //                   type: "",
        //                   redirectionPage: location.pathname
        //                 }
        //               ));
        //             }
        //             const path = shortcutKeyForPage(location.pathname, event);
        //             if (path) {
        //               history.push('/' + path);
        //             }
        //           }
        //         });
        // });

        function getPrinterName(printerType) {
                let name = '';
                const printers = JSON.parse(localStorage.getItem('Printers'));
                if (printerType === 'bt') {
                        name = printers.bagTag ? printers.bagTag.name : ''
                }
                if (printerType === 'bp') {
                        name = printers.boardingPass ? printers.boardingPass.name : ''
                }
                return name
        }

        function disablePrinterPopup() {
                dispatch(printerPopupSearchPageCredential(
                        {
                                type: "",
                                isPrinterPopupSearchPageOpen: false,
                        
                        }
                ));
        }

// update
useEffect(() => {
  if (divRefs.current[activeIndex]) {
      divRefs.current[activeIndex].focus();
  }
}, [activeIndex]);

// this is solution for handle last element checkbox
const trapFocus = (e, divIndex) => {
const container = divRefs.current[divIndex];
if (!container) return;

const focusableElements = container.querySelectorAll(
  'input, button, textarea, a[href], [tabindex]:not([tabindex="-1"])'
);

if (focusableElements.length === 0) return;

const firstElement = focusableElements[0];
const lastElement = focusableElements[focusableElements.length - 1];

// If Shift + Tab is pressed on the first element, move focus to the last
if (e.shiftKey && e.key === "Tab" && document.activeElement === firstElement) {
  e.preventDefault();
  lastElement.focus();
} 
// If Tab is pressed on the last element, move focus to the first
else if (!e.shiftKey && e.key === "Tab" && document.activeElement === lastElement) {
  e.preventDefault();
  firstElement.focus();
}
};

const handleKeyDown = (e) => {
};

useEffect(() => { 
const handleKeyDown = (e) => {
        if (e.altKey && e.key.toLowerCase() === 'c') {
        if(!IsModulAndLoginDivDisabled){
                dispatch(moduleAndLoginDivDisabled({
                        type: "MODULE_AND_LOGINDIV_DISABLED",
                        IsModulAndLoginDivDisabled: true
                        }));
                const searchBtn = document.getElementById("searchBooking");
                const nextBtn = document.getElementById("btnNextButton");
                if (location.pathname === '/Search' && searchBtn && nextBtn === null) {             
                                fncFocusElementDependsOnPathLocation(location.pathname,inputElementForPNR.current);
                    } else if (nextBtn && nextBtn.disabled === false) {
                        fncFocusElementDependsOnPathLocation(location.pathname,lastFocusedCheckboxRef.current);
                }
            }
            else if (IsModulAndLoginDivDisabled) {
                const headingDiv = document.querySelector(".modulebtn");            
                if (headingDiv) {                  
                    headingDiv.focus();
                    dispatch(moduleAndLoginDivDisabled({
                            type: "MODULE_AND_LOGINDIV_DISABLED",
                            IsModulAndLoginDivDisabled: false
                        }));
                }
            }
           } else if (e.shiftKey && e.key === "ArrowUp") {  
              setAllpassenger(true);
  if (passengerDivRef.current) {
    passengerDivRef.current.tabIndex = 0;
    passengerDivRef.current.focus(); 
  }
} 
else if (e.shiftKey && e.key === "ArrowDown") {
             setAllpassenger(false);               
             if (divRefs.current[activeIndex]) {
                     divRefs.current[activeIndex].focus();            
                     if (lastFocusedCheckboxRef.current) {
                             lastFocusedCheckboxRef.current.focus();
                        }
                }  
} 
else if(!Allpassenger){
        if (e.key === "ArrowDown") {
                e.preventDefault();
                setActiveIndex((prevIndex) => {
                    let newIndex = Math.min(prevIndex + 1, divRefs.current.length - 1);
                    let targetDiv = divRefs.current[newIndex];
          
                    while (newIndex < divRefs.current.length && targetDiv) {
                        const checkboxes = Array.from(targetDiv.querySelectorAll("input[type='checkbox']"));
                        const enabledCheckboxes = checkboxes.filter(cb => !cb.disabled);
          
                        if (enabledCheckboxes.length > 0) {
                            targetDiv.focus();
          
                            // Click all enabled checkboxes
                            enabledCheckboxes.forEach((cb) => {
                                if (!cb.checked) {
                                    cb.click();
                                }
                            });
          
                            let firstUnchecked = enabledCheckboxes.find(cb => !cb.checked) || enabledCheckboxes[0];
                            firstUnchecked.focus();
                            lastFocusedCheckboxRef.current = firstUnchecked;
          
                            return newIndex;
                        }
          
                        // Move to the next div
                        newIndex++;
                        targetDiv = divRefs.current[newIndex];
                    }
          
                    return prevIndex;
                });
            } 
            else if (e.key === "ArrowUp") {
                e.preventDefault();
                setActiveIndex((prevIndex) => {
                    let newIndex = Math.max(prevIndex - 1, 0);
                    let targetDiv = divRefs.current[newIndex];
          
                    while (newIndex >= 0 && targetDiv) {
                        const checkboxes = Array.from(targetDiv.querySelectorAll("input[type='checkbox']"));
                        const enabledCheckboxes = checkboxes.filter(cb => !cb.disabled);
          
                        if (enabledCheckboxes.length > 0) {
                            targetDiv.focus();
          
                            // Click all enabled checkboxes
                            enabledCheckboxes.forEach((cb) => {
                                if (!cb.checked) {
                                    cb.click();
                                }
                            });
          
                            let lastChecked = enabledCheckboxes.find(cb => !cb.checked) || enabledCheckboxes[0];
                            lastChecked.focus();
                            lastFocusedCheckboxRef.current = lastChecked;
          
                            return newIndex;
                        }
          
                        // Move to the previous div
                        newIndex--;
                        targetDiv = divRefs.current[newIndex];
                    }
          
                    return prevIndex;
                });
            }
}
};


document.addEventListener("keydown", handleKeyDown);
return () => {
document.removeEventListener("keydown", handleKeyDown);
};
}, [IsModulAndLoginDivDisabled, location.pathname, dispatch, activeIndex, Allpassenger]);


// Restore focus to checkboxes when coming back to a div
useEffect(() => {
if (divRefs.current[activeIndex]) {
const targetDiv = divRefs.current[activeIndex];
// Remove the highlight from all divs before applying to the active one
divRefs.current.forEach((div) => {
if (div) div.classList.remove("highlighted-div");
},[activeIndex]);

// Apply the orange outline and shadow
targetDiv.classList.add("highlighted-div");
// Try focusing last focused checkbox inside the div
if (lastFocusedCheckboxRef.current && targetDiv.contains(lastFocusedCheckboxRef.current)) {
  lastFocusedCheckboxRef.current.focus();
} else {
  // If no last checkbox, focus first checkbox
  const checkboxes = Array.from(targetDiv.querySelectorAll("input[type='checkbox']"));
  if (checkboxes.length > 0) {
      checkboxes[0].focus();
      lastFocusedCheckboxRef.current = checkboxes[0];
  }
}
}
}, [activeIndex]);

useEffect(() => {
if (divRefs.current[activeIndex]) {
      const targetDiv = divRefs.current[activeIndex];
     // Remove the highlight from all divs before applying to the active one
     divRefs.current.forEach((div) => {
      if (div) div.classList.remove("highlighted-div");
  });

  // Apply the orange outline and shadow
  targetDiv.classList.add("highlighted-div");
   // Try focusing last focused checkbox inside the div
if (lastFocusedCheckboxRef.current && targetDiv.contains(lastFocusedCheckboxRef.current)) {
      lastFocusedCheckboxRef.current.focus();
  } else {
      // If no last checkbox, focus first checkbox
      const checkboxes = Array.from(targetDiv.querySelectorAll("input[type='checkbox']"));
      if (checkboxes.length > 0) {
          checkboxes[0].focus();
          lastFocusedCheckboxRef.current = checkboxes[0];
      }
  }
}
},[]);
// this is for control shift key  movement
  useEffect(() => {
      const handleGlobalKeyDown = (e) => {
          handleKeyDown(e, "SEGMENT", activeIndex);
      };            
      document.addEventListener("keydown", handleGlobalKeyDown);
      return () => {
        document.removeEventListener("keydown", handleGlobalKeyDown);
      };
  }, [activeIndex]);

useEffect(() => {
const handleKeyDown = (e) => {
if (e.key === "Tab") {
if (
document.activeElement.id === "PeripheralCancleBtn" && 
!e.shiftKey
) {
e.preventDefault();
yesbutton.current?.focus(); 
}
if (
document.activeElement.id === "ChangePrinters" && 
!e.shiftKey
) {
e.preventDefault();
proceed.current?.focus(); // Move focus to  button
}

}
}
document.addEventListener("keydown", handleKeyDown);
return () => {
document.removeEventListener("keydown", handleKeyDown);
};
});
useEffect(() => {
      if (showlocalStoragePrinterPopup && PrintModeModalStatus && selectedMode == "Native") {
              proceed.current.focus();
      }
}, [showlocalStoragePrinterPopup]);
useEffect(() => {
        if (modalShow) {
                CancleBtnRef.current.focus();
        }
}, [modalShow]);


const options = [
    { value: 'Native', label: 'Native' },
    { value: 'SITA FLEX', label: 'SITA FLEX' }
];

const handleSelectChange = (value) => {
    dispatch(setPrintMode({ selectedMode: value }));
    if(value == "SITA FLEX"){
        localStorage.removeItem("Printers");
    }
  };

  const handleSubmit = () => {
        if (selectedMode === "SITA FLEX") {
                history.push("/PeripheralDevices", { selectedMode });
        }else{
                dispatch(FetchPrintModeModalStatus({PrintModeModalStatus: true}));
        }
  };

  const printModePopupCancelClick = () =>{
        dispatch(FetchPrintModeModalStatus({PrintModeModalStatus: true}));                
   }
         
        return (
                <div className="">
                        {/* <Header  handleSideMenu={handleSideMenu} />  */}
                        <LogoutModel trigger={triggerModal}> </LogoutModel>
                        {/* Modal starts herre */}
                        <PrintModeModal
                        show={!PrintModeModalStatus}
                        title="Select Print Mode"
                        options={options}
                        selectedValue={selectedMode}   // ✅ Correct: actual selected value
                        onSelectChange={handleSelectChange}
                        onSubmit={handleSubmit}
                        onCancel={printModePopupCancelClick}
                        submitText="Submit"
                        cancelText="Cancel"
                        />
        
                        <Modal
                                show={showPrinterPopup && selectedMode === "Native" && PrintModeModalStatus}
                                onHide={fncPopupCancelClick}
                                backdrop="static"
                                keyboard={true}
                                className="clsQuickAssign"
                        >
                                <Modal.Header >
                                <Modal.Title>No Peripheral Devices found</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                Proceed to select printers for printing boarding pass and bag tags
                                </Modal.Body>
                                <Modal.Footer>
                                <button ref={yesbutton} className="focusClass btn btn-red OrangeShadow" onClick={fncGoToPeripheralDevices}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    fncGoToPeripheralDevices();
                                  }}}>Yes</button>
                                <button className="focusClass btn btn-red OrangeShadow" onClick={fncPopupCancelClick} id="PeripheralCancleBtn">
                                No
                                </button>
                                </Modal.Footer>
                        </Modal>
                        <Modal
                                show={showlocalStoragePrinterPopup && selectedMode === "Native" && PrintModeModalStatus}
                                onHide={fncPopupCancelClick}
                                backdrop="static"
                                keyboard={true}
                                className="clsQuickAssign"
                        >
                                <Modal.Header>
                                <Modal.Title>Peripheral Devices found</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                <div class="bagform">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class=" mb-3">
                                                <p class="font-md bold dark-text mb-1">Boarding Pass Printer</p>
                                                <p class="font-md  grey-text mb-1">{ localStorage.getItem("Printers") ? getPrinterName('bp') : ''}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class=" mb-3">
                                                <p class="font-md bold dark-text mb-1">Bag Tags Printer</p>
                                                <p class="font-md  grey-text mb-1">{localStorage.getItem("Printers") ? getPrinterName('bt') : ''}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class=" mb-3">

                                                <p class="font-md  grey-text mb-1" tabIndex={-1}>Do you want to proceed further?</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                </Modal.Body>
                                <Modal.Footer>
                                <button className="focusClass btn btn-red OrangeShadow" tabIndex={1} ref={proceed} onClick={fncPopupCancelClick}>
                                Proceed
                                </button>
                                <button className="focusClass btn btn-red OrangeShadow" tabIndex={1} id='ChangePrinters' onClick={fncGoToPeripheralDevices}
                                onKeyDown={(e) => {
                                                if (e.key === "Enter" || e.key === " ") {
                                                  fncGoToPeripheralDevices();
                                                }}}
                                                >Change Printers</button>
                                </Modal.Footer>
                        </Modal>
                        {/* Modal ends here */}
                        <div class="full-container collapse" id="collapseExample" inert>
        <div class="card mt-3 py-3">
            <div class="search-outer primary">
                <div class="search">
                    <input class="focusClass font-md input-box1" ref={inputElementForPNR}   id="RECORDLOCATOR" type="text" name="search" placeholder="Search PNR" value={recordlocator} onChange={(e) => { fncOnchange(e, "clsRecordLocatorField") }} />
                    <p className="clsErrorForPnrSearch" >{st_ErrorBookingRecordLocator}</p>
                    <div class="icon">
                        <img src="newImages/search-dark.svg" alt="icon-search" onClick={() => { fncSearchButtonClick("ONPOPUP") }} />
                    </div>
                </div>
                <div class="search-checkbox">
                        {/* need to remove form-check in below div class to enable checkbox select and deselect using keyboard */}
                    <div class="font-md me-4">
                        <input class="focusClass form-check-input search-Check checkbox-input" onChange={(e) => { fncOnchangeQuickSearchCriteria(e) }} id="QUICKSEARCHCRITERIA" checked={isQuickSearch} name="searchType" type="checkbox"/>
                        <label class="form-check-label font-md white-text" for="QUICKSEARCHCRITERIA">
                            Quick Search
                        </label>
                    </div>
                    <div class=" font-md">
                        <input class="focusClass form-check-input search-Check checkbox-input" name="searchType" type="checkbox" onChange={(e) => { fncOnchangeDisregardCriteria(e) }} id="DISREGARDCRITERIA" checked={isDisregard} />
                        <label class="form-check-label font-md white-text" for="DISREGARDCRITERIA">
                            Advance Search
                        </label>
                    </div>
                </div>
            </div>
            <div class="advanceSearch">
                <h4 class="dark-text bold font-xxl mb-3">Advance Search</h4>
                <div class="row">
                
                    <div class="col-lg-4 col-md-6 mb-4 ">
                    {(isDisregard || isQuickSearch) ?
                <div class="form-floating date ">
                        <input type="text" value="" disabled class="form-control" id="dateInput" placeholder="DD/MM/YYYY" />
                        {/* <span class="icon">
                        <img class="icon-24" src="newImages/icon-date.svg"/>
                        </span> */}
                        <label for="dateInput">Date</label>
                </div>
                :
                <div class="form-floating date ">
                        <DatePicker     popperClassName="custom-datepicker"
 // update i took custome input it was not in sequence of tab and added tabIndex={1}
                                                                                        customInput={
                                                                                                <input
                                                                                                ref={datepickerRef}
                                                                                                        className="form-control focusClass"
                                                                                                        id="dateInput"
                                                                                                        placeholder="DD/MM/YYYY"
                                                                                                        autoComplete="new-date"
                                                                                                        tabIndex={1}
                                                                                                />
                                                                                        }
                                                                                        name="date"
                                                                                        dateFormat="dd-MM-yyyy"
                                                                                        selected={st_date}
                                                                                        onSelect={(e) => { handleDateSelect(e) }}
                                                                                        onChange={(e) => { handleDateChange(e) }}
                                                                                        autoFocus
                                                                                />
                        <span class="icon">
                        <img class="icon-24" src="newImages/icon-date.svg"/>
                        </span>
                        <p className="clsErrorDate" >{st_ErrorDate}</p>
                        </div>
                }
                        
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 ">
                        <div class="departure">
                            <div class="icon">
                                <img src="newImages/departure.svg" alt="departure" />
                            </div>
                            <div class="form-floating">
                                {
                                        (isDisregard || isQuickSearch) ?
                                        <input type="text" disabled value="" class="form-control" placeholder='Departure' />
                                        :
                                        <select class="form-select focusClass" value={origin} onChange={e => fncOriginChange(e)} id="departure" aria-label="departure">
                                        <option id="0">Select a Origin</option>
                                        {
                                            ReduxOriginDropdown.length === 0 ? '' : ReduxOriginDropdown.map((dest, i) =>
                                                <option id={dest.stationCode} key={i}>{dest.stationCode}</option>
                                            )
                                        }
                                        </select>
                                }
                                <label for="departure">Departure</label>
                            </div>
                            <p className="clsError" >{st_ErrorOrigin}</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4">
                        <div class="arrival">
                            <div class="icon">
                                <img src="newImages/arrival.svg" alt="arrival" />
                            </div>
                            <div class="form-floating ">
                                {
                                        (isDisregard || isQuickSearch) ?
                                        <input type="text" disabled value="" class="form-control" placeholder='Arrival' />
                                        :
                                        <select class="form-select focusClass" value={destination} onChange={e => fncDestinationChange(e)} id="arrival" aria-label="arrival">
                                                <option id="0">Select a Destination</option>
                                                {
                                                        ReduxDestinationDropdown.length === 0 ? '' : ReduxDestinationDropdown.map((dest, i) =>
                                                                <option id={dest.stationCode}>{dest.stationCode}</option>
                                                        )
                                                }
                                        </select>
                                }
                                <label for="arrival">Arrival</label>
                            </div>
                        </div>
                    </div>
                </div>
                <h4 class="dark-text bold font-lg mt-3 mb-3 highlight-heading">Passenger</h4>
                <div class="row">
                    <div class="col-lg-4 col-md-6 mb-4 ">
                        <div class="form-floating  ">
                                {(isDisregard || isQuickSearch) ?
                                <input type="text" value="" disabled class="form-control" id="fname" placeholder="First Name" />
                                :
                                <input type="text" class="form-control focusClass" id="FIRSTNAME" onChange={(e) => { fncOnchange(e, "clsFirstNameField") }} autocomplete="new-fname" value={firstName} placeholder="First Name" />
                                }                            
                            <label for="fname">First Name</label>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 ">
                        <div class="form-floating  ">
                                {(isDisregard || isQuickSearch) ?
                                <input type="text" disabled class="form-control" id="LASTNAME" value="" placeholder="Last Name" />
                                :
                                <input type="text" class="form-control focusClass" id="LASTNAME" onChange={(e) => { fncOnchange(e, "clsLastNameField") }} value={lastName} placeholder="Last Name" />
                                }                           
                            <label for="lname">Last Name</label>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 ">
                        <div class="form-floating  ">
                                {(isDisregard || isQuickSearch) ?
                                <input type="text" disabled class="form-control" id="BOOKINGRECORDLOCATOR" value="" placeholder="booking" />
                                :
                                <input type="text" id="BOOKINGRECORDLOCATOR" onChange={(e) => { fncOnchange(e, "clsRecordLocatorField") }} value={bookingRecordlocator} class="form-control focusClass" placeholder="booking" />
                                }
                                <label for="booking">Booking (Record Locator)</label>
                                <p className="clsErrorDate" >{st_ErrorRecordLocator}</p>
                        </div>
                    </div>
                </div>
                <h4 class="dark-text bold font-lg mt-3 mb-3 highlight-heading">Flight</h4>
                <div class="row">
                    <div class="col-lg-4 col-md-6 mb-4 ">
                        <div class="form-floating  ">
                                {
                                        (isDisregard || isQuickSearch) ?
                                        <input type="text" value="" disabled class="form-control" id="flight" placeholder="flight Name" />
                                        :
                                        <select class="form-select focusClass">
                                                <option id={process.env.REACT_APP_AirlineCode}>{process.env.REACT_APP_AirlineCode}</option>
                                        </select>
                                }                           
                            <label for="flight">Flight Name</label>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 ">
                        <div class="form-floating  ">
                                {
                                        (isDisregard || isQuickSearch) ?
                                        <input value="" disabled type="text" class="form-control" id="FLIGHTNUM" placeholder="Flight No" />
                                        :
                                        <input type="text" id="FLIGHTNUM" onChange={(e) => { fncOnchange(e, "clsFlightNoField") }} value={flightnum} class="form-control focusClass" />
                                }                            
                                <label for="flightNo">Flight No.</label>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 ">
                        <div class="form-floating  ">
                                {(isDisregard || isQuickSearch) ?
                                <input type="text" value="" disabled class="form-control" placeholder="opSuffix" id="OPSUFFIX" />
                                :
                                <input type="text" class="form-control focusClass" placeholder="opSuffix" id="OPSUFFIX" onChange={(e) => { fncOnchange(e, "clsOpSuffixField") }} value={opsuffix} />
                                }                           
                                <label for="opSuffix">OP Suffix</label>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end mt-3">
                <input type="submit" id="searchBooking" disable={SearchBtnDisable} onClick={() => { fncSearchButtonClick("ONPOPUP") }} class="btn btn-primary btn-animation px-4 SerachBtn" value="Search" />
                    {/* <a href="#" class="btn btn-primary btn-animation">
                        <span class="px-4">Search</span>
                    </a> */}
                </div>
            </div>
        </div>
    </div>




                        {/* ------------------- new -------------------------------------------------------- */}
                        <div class="full-container pb-5">
                                <div class="card mt-3 py-3 px-4 mb-4" style={{ display: st_SearchVisibility }}>
                                        <div class="search-result-heading">
                                                <h4 class="dark-text bold font-xxl mb-3 " style={{ display: st_SearchVisibility }}>
                                                        <a role="button"
                                                                onClick={fncSearchDivOpen}
                                                                style={{ display: st_SearchVisibility }}
                                                                id="btnSearchPassengerRecord" class="icon me-2 backBtn focusClass"
                                                                data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"
                                                                 tabindex="0"
                                                                tabIndex={-1} ref={searchButtonRef}
                                                        >
                                                                <img src="newImages/left-arrow.svg" />
                                                        </a>Search Result
                                                </h4>
                                        </div>
                                        {
                                                NODATAFOUND == true ? <div className="centerdErrorMessage">No result found.Please refine your search terms</div> : stSearchedRecordData.length === 0 ? "" :
      
                                                        <div class="passengerList ">
                                                                <div class="pLHeading">
                                                                <div class="fNo">
                                                                                <p class="font-md bold dark-text mb-0">Flight No.</p>
                                                                        </div>
                                                                        <div class="pLUsers">
                                                                                <div class="icons"> </div>
                                                                          <FocusLock disabled={!Allpassenger}>
                                                                                <div class="pLName d-flex focusClass">
                                                                                        <input class="me-2 form-check-input checkbox-input"
                                                                                          tabIndex={isAltSActivated ? 0 : -1} ref={passengerDivRef} 
                                                                                        type="checkbox" checked={selectAllPassenger} onChange={(e) => { fncSelectAllPassenger(e) }} id="selectAllPassengers" name="plName" />
                                                                                        <label for="plName" class="font-md bold dark-text mb-0">Passenger List</label>
                                                                                </div>
                                                                                </FocusLock>
                                                                        </div>
                                                                       
                                                                        <div class="fDetails">
                                                                                <p class="font-md bold dark-text mb-0">Flight Details</p>
                                                                        </div>
                                                                        <div class="actions"></div>
                                                                </div>
                                                         <div className='allpassengerlist'>
                                                                {stSearchedRecordData.length === 0 ? ""
                                                                        :
                                                                      stSearchedRecordData.map((items, i) => (
                                                                                <div
                                                                                className={`divborder ${items.passengerData.some(passenger => 
                                                                                        passenger.segments.some(seg => seg.IsSelected) || 
                                                                                        passenger.passengers.some(pas => pas.IsSelected)
                                                                                    ) ? "highlighted-div" : ""}`}
                                                                                      key={i} 
                                                                                        ref={(el) => (divRefs.current[i] = el)} 
                                                                                       onKeyDown={(e) => {
                                                                                                handleKeyDown(e);
                                                                                                if (activeIndex === i) {
                                                                                                  trapFocus(e, i);
                                                                                                }
                                                                                              }}
                                                                                      
                                                                                >
                                                                                        {/* Passenger Details */}
                                                                                        {items.passengerData.map((item, jj) => (
                                                                                                <div className="pLDetails" key={`${i}-${jj}`}   
                                                                                                  >  {/* Segment Details */}
                                                                                                        <div className="fNo">
                                                                                                                {/* <p className="font-md bold dark-text flight-label">Flight No.</p> */}
                                                                                                                {item.segments.map((seg, k) => (   <div key={k} className="d-flex">
                                                                                                                                <input  className="me-2 form-check-input focusClass checkbox-input" type="checkbox"    id={seg.segmentKey}
                                                                                                                                        checked={seg.IsSelected}
                                                                                                                                        onChange={(e) => {fncPassengerSelection( e,   `${items.recordLocator}-${jj}`, "SEGMENT",  "", `${i}-${jj}`)  }    } 
                                                                                                                                        // tabIndex={k}
                                                                                                                                        onKeyDown={(e) => {
                                                                                                                                                handleKeyDown(e, "SEGMENT", k, i)
                                                                                                                                                  }}
      
                                                                                                                                        />
                                                                                                                               
                                                                                                                                <label className="font-md mid-dark-text mb-0">
                                                                                                                                        {seg.carrierCode} {seg.flightNumber}
                                                                                                                                </label>
                                                                                                                        </div>
                                        
                                                                                                                                             ))}
                                                                                                        </div>
                                                                                                        <div className="pLUsers">
                                                                                                                <p className="font-md bold dark-text passenger-label">Passenger List</p>
                                                                                                                <div className="pList">
                                                                                                                        {item.passengers.map((pax, j) => (
                                                                                                                                <div key={j} className="pLUsersItem">
                                                                                                                                        <div className="icons">
                                                                                                                                                <img src={searchPageIconsMapping[pax.IsCheckedIn]} alt="status-icon" />
                                                                                                                                        </div>
                                                                                                                                        <div className="pLName d-flex">
                                                                                                                                                <input
                                                                                                                                                        className="me-2 form-check-input focusClass checkbox-input"
                                                                                                                                                        type="checkbox"
                                                                                                                                                        name={pax.passengerKey}
                                                                                                                                                        id={pax.passengerKey}
                                                                                                                                                        checked={pax.IsSelected}
                                                                                                                                                        onChange={(e) =>
                                                                                                                                                                fncPassengerSelection(
                                                                                                                                                                        e,
                                                                                                                                                                        `${items.recordLocator}-${jj}`,
                                                                                                                                                                        "PASSENGER",
                                                                                                                                                                        `${pax.title} ${pax.firstName} ${pax.lastName}`,
                                                                                                                                                                        `${i}-${jj}`
                                                                                                                                                                )
                                                                                                                                                        }
                                                                                                                                                />
                                                                                                                                                <label
                                                                                                                                                        data-tip
                                                                                                                                                        data-for={`${pax.firstName}`}
                                                                                                                                                        className="font-md mid-dark-text mb-0 lable"
                                                                                                                                                >
                                                                                                                                                        {stSearchedFlightDetails &&
                                                                                                                                                                stSearchedFlightDetails.recordLocator === items.recordLocator &&
                                                                                                                                                                eltPnr
                                                                                                                                                                ? `${pax.lastName}, ${pax.firstName} ${pax.title}**`
                                                                                                                                                                : stSearchedFlightDetails &&
                                                                                                                                                                        stSearchedFlightDetails.recordLocator === items.recordLocator &&
                                                                                                                                                                        sodPnr
                                                                                                                                                                        ? `${pax.lastName}, ${pax.firstName} ${pax.title}*`
                                                                                                                                                                        : `${pax.lastName}, ${pax.firstName} ${pax.title}`}
                                                                                                                                                </label>
                                                                                                                                                {(eltPnr || sodPnr) && (
                                                                                                                                                        <ReactTooltip id={`${pax.firstName}`} place="right" effect="solid">
                                                                                                                                                                {eltPnr ? ` (ELT PNR)` : sodPnr ? ` (SOD PNR)` : null}
                                                                                                                                                        </ReactTooltip>
                                                                                                                                                )}
                                                                                                                                        </div>
                                                                                                                                </div>
                                                                                                                        ))}
                                                                                                                </div>
                                                                                                        </div>
      
                                                                                                    
                                                                                                        {/* Flight Details */}
                                                                                                        <div className="fDetails">
                                                                                                                {/* <p className="font-md bold dark-text flight-details-label">Flight Details</p> */}
                                                                                                                <div className="d-flex fDetailsData">
                                                                                                                        <div className="fDetailsLeft">
                                                                                                                                <p className="font-xs mid-dark-text mb-1">
                                                                                                                                        {items.passengerData[0].passengers[0].lastName},{" "}
                                                                                                                                        {items.passengerData[0].passengers[0].firstName},{" "}
                                                                                                                                        {items.passengerData[0].passengers[0].title} + {items.passengerCount - 1}px
                                                                                                                                </p>
                                                                                                                                <p className="semibold primary-text mb-1 font-sm">PNR- {items.recordLocator}</p>
                                                                                                                                <p className="font-xs mid-dark-text mb-1">
                                                                                                                                        Seg Count - {items.passengerData[0].segments.length}
                                                                                                                                </p>
                                                                                                                        </div>
                                                                                                                        {item.segments.map((seg, k) => (
                                                                                                                                <div key={k} className="fDetailsRight me-3">
                                                                                                                                        <div className="flightTimeLeft">
                                                                                                                                                <p className="font-xs mid-dark-text mb-0">
                                                                                                                                                        {moment(seg.departureTime).format("HH:mm")}
                                                                                                                                                </p>
                                                                                                                                                <p className="semibold dark-text mb-0 font-lg">{seg.origin}</p>
                                                                                                                                                <p className="font-xs mid-dark-text mb-0">
                                                                                                                                                        {moment(seg.departureTime).format("ddd, D MMM")}
                                                                                                                                                </p>
                                                                                                                                        </div>
                                                                                                                                        <div className="flightCenter">
                                                                                                                                                <p className="font-xs mid-dark-text mb-1">
                                                                                                                                                        {seg.carrierCode} {seg.flightNumber}
                                                                                                                                                </p>
                                                                                                                                                <div className="flightIcon">
                                                                                                                                                        <img src="newImages/flight-timing.svg" alt="flight" />
                                                                                                                                                </div>
                                                                                                                                        </div>
                                                                                                                                        <div className="flightTimeRight">
                                                                                                                                                <p className="font-xs mid-dark-text mb-0">
                                                                                                                                                        {moment(seg.arrivalTime).format("HH:mm")}
                                                                                                                                                </p>
                                                                                                                                                <p className="semibold dark-text mb-0 font-lg">{seg.destination}</p>
                                                                                                                                                <p className="font-xs mid-dark-text mb-0">
                                                                                                                                                        {moment(seg.arrivalTime).format("ddd, D MMM")}
                                                                                                                                                </p>
                                                                                                                                        </div>
                                                                                                                                </div>
                                                                                                                        ))}
                                                                                                                </div>
                                                                                                        </div>
                                                                                                </div>
                                                                                        ))}
                                                                                </div>
                                                                        ))
      
                                                                }
                                                          </div>
                                                        </div>
                                        }
                                </div>
                                {
                                        st_SearchVisibility === 'flex' ?
                                                <div class="btn-container justify-content-end d-flex focusClass">
                                                        <button class="lookupNextBtn focusClass" id="btnNextButton" disabled={isDisabled} onClick={fncNext} tabindex="0" >
                                                                <span class="px-4"> Next<span class="icon ms-2"><img src="newImages/i-arrow-right.svg" /> <img src="newImages/i-arrow-right.svg" /></span></span>
                                                        </button>
                                                </div>
                                                : null
                                }
                        </div>
                        {/* ----------------------- new ends here ---------------------------------------- */}

                        
                        {/* //-------------------------------------------- search div ends here ------------------- */}
                        {/* <div class="footer" >
                                <div class="row" style={{ "margin": "0px", "marginTop": "10px" }}>
                                        <div className="col-6 col-md-6 col-lg-11 clsSearchedDiv" style={{ "padding": "0px" }}>
                                                <button onClick={fncSearchDivOpen} id="btnSearchPassengerRecord" class="btn btn-primary btnSearch" type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
   <img src="./Images/search.png" style={{"height":"20px"}} />     Search Passenger Record
  </button>
                                        </div>

                                        
                                </div>
                        </div> */}

                        {/* // --------------------------------------------- footer ends here ------------------------------- */}


                        <Modal
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                                size="md"
                                keyboard={true}
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                                className="clsSearchModal"
                        >
                                <Modal.Header>
                                        <Modal.Title id="contained-modal-title-vcenter">
                                                Cannot Check In
                                        </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                        <h4>The selected passenger and flights cannot be checked in using this application.</h4>
                                        <p>Reason.</p>
                                        <p>
                                                {"- " + Error_FlightStatus}
                                        </p>
                                </Modal.Body>
                                <Modal.Footer>
                                        {/* <Button onHide={() => setModalShow(false)}>Continue anyway</Button> */}
                                        <Button id="cancelButtonForCannotCheckin" ref={CancleBtnRef} className="focusClass btn btn-red OrangeShadow" onClick={handleCloseshowErrorPopup}>Cancel</Button>
                                </Modal.Footer>
                        </Modal>
                </div>
        );
}

export default Search;